import React, { useState, useEffect, useRef } from 'react';
import {
  Search, Plus, ArrowLeft, Zap, CreditCard, Smartphone,
  Eye, Pencil, ArrowRight, Trash2, UserCheck, Users, CloudUpload,
  CreditCard as CardIcon, Star, X, Download, DollarSign, RefreshCw,
  FileText, Mail, Phone, ChevronLeft, ChevronDown, ChevronRight, Filter, Save
} from 'lucide-react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getClients, getDistinctClients, recalcClientStatus, getCelcoinClients } from '../services/api';
import { getAsaasClients, updateAsaasClient } from '../services/asaasApi';
import './Clients.css';
import CpflStep2 from '../components/CpflStep2';
import AsaasStep2 from '../components/AsaasStep2';
import PixStep2 from '../components/PixStep2';
import PixClientsTab from '../components/PixClientsTab';
import '../components/AsaasStep2.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
import ClientPaymentsModal from '../components/ClientPaymentsModal';
import AnexosCpflButton from '../components/AnexosCpflButton';
import { useAuth } from '../contexts/AuthContext';
import './ClientsPagamento.css';
import { modalidadesPorUsuario } from '../services/modalidades';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// ── Constantes ───────────────────────────────────────────────────────────────
// Campo de data digitável (dd/mm/aaaa). Recebe e devolve AAAA-MM-DD (ou '' se incompleta/inválida).
const isoParaBR = (iso) => (/^\d{4}-\d{2}-\d{2}$/.test(iso || '') ? iso.split('-').reverse().join('/') : '');
const brParaISO = (txt) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(txt || '');
  if (!m) return '';
  const [, dd, mm, aa] = m;
  const d = new Date(Number(aa), Number(mm) - 1, Number(dd));
  const ok = d.getFullYear() === Number(aa) && d.getMonth() === Number(mm) - 1 && d.getDate() === Number(dd) && Number(aa) >= 1900;
  return ok ? `${aa}-${mm}-${dd}` : '';
};
function DataBRInput({ value, onChange }) {
  const [txt, setTxt] = useState(isoParaBR(value));
  useEffect(() => {
    if ((value || '') !== brParaISO(txt)) setTxt(isoParaBR(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const invalida = txt.length === 10 && !brParaISO(txt);
  return (
    <input
      type="text"
      inputMode="numeric"
      placeholder="dd/mm/aaaa"
      maxLength={10}
      value={txt}
      style={invalida ? { borderColor: '#dc2626' } : undefined}
      onChange={(e) => {
        const d = e.target.value.replace(/\D/g, '').slice(0, 8);
        const mascarado = d.length > 4 ? `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}` : d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d;
        setTxt(mascarado);
        onChange(brParaISO(mascarado));
      }}
    />
  );
}

const emptyDep = { nome: '', dataNascimento: '', grau: 'filho' };
const grauLabels = { filho: 'Filho(a)', conjuge: 'Cônjuge', pai: 'Pai/Mãe', agregado: 'Agregado' };

// ── PASSO 3 CPFL ─────────────────────────────────────────────────────────────
function CpflStep3({ cpflData, onBack, onSave, onSaveAndCharge }) {
  const [titular, setTitular] = useState({
    nome: '', cpf: '', rg: '', dataNascimento: '', estadoCivil: '',
    vendedor: '', dataCadastro: new Date().toISOString().slice(0, 10),
    nacionalidade: 'Brasileiro(a)', telefone: '', celular: '', plano: '',
    valorPlano: '',
  });
  const [depForm, setDepForm] = useState(emptyDep);
  const [dependentes, setDependentes] = useState([]);
  const [saving, setSaving] = useState(false);
  const [savedOk, setSavedOk] = useState(false);

    useEffect(() => {
    if (cpflData && Object.keys(cpflData).length > 0 && cpflData.titularDoPlano) {
      setTitular(prev => ({
        ...prev,
        nome: cpflData.nome || '',
        cpf: cpflData.cpf || '',
        rg: cpflData.rg || '',
        dataNascimento: cpflData.dataNascimento || '',
        telefone: cpflData.telResidencial || '',
        celular: cpflData.telCelular || '',
      }));
    }
    // Se titularDoPlano === false, deixa os campos em branco: o titular do
    // plano é uma pessoa diferente do titular da conta CPFL.
  }, [cpflData]);

  const setT = (k, v) => setTitular(p => ({ ...p, [k]: v }));
  const setD = (k, v) => setDepForm(p => ({ ...p, [k]: v }));
  const addDependente = () => {
    if (!depForm.nome) return;
    setDependentes(p => [...p, { ...depForm, id: Date.now() }]);
    setDepForm(emptyDep);
  };
  const removeDep = (id) => setDependentes(p => p.filter(d => d.id !== id));
  const calcIdade = (dob) => {
    if (!dob) return '';
    const diff = Date.now() - new Date(dob).getTime();
    return `(${Math.floor(diff / (1000 * 60 * 60 * 24 * 365))})`;
  };

    const buildPayload = () => {
    const formatDateToDDMMYYYY = (dateStr) => {
      if (!dateStr) return '';
      if (dateStr.includes('-')) {
        const [year, month, day] = dateStr.split('-');
        return `${day}${month}${year}`;
      }
      return dateStr.replace(/\D/g, '');
    };

    // ⚠️ A CPFL exige que CPF/RG/Data de Nascimento sejam os do TITULAR DA
    // INSTALAÇÃO CPFL (Step 2) — não do "titular do plano" (Step 3), que pode
    // ser outra pessoa (ex: um dependente sendo o titular do plano de saúde).
    // cpflData.* é a fonte principal; titular.* só entra como reserva se o
    // Step 2 não tiver capturado esses dados.
    const isPJ = cpflData?.tipoPessoa === 'juridica';
    const cpfFinal = (cpflData?.cpf || titular.cpf || '').replace(/\D/g, '');
    const rgFinal = cpflData?.rg || titular.rg || '';
    const dataNascFinal = cpflData?.dataNascimento
      ? formatDateToDDMMYYYY(cpflData.dataNascimento)
      : formatDateToDDMMYYYY(titular.dataNascimento);
    const nomeFinal = cpflData?.nome || titular.nome || '';
    const telFixoFinal = (cpflData?.telResidencial || titular.telefone || '').replace(/\D/g, '');
    const telCelularFinal = (cpflData?.telCelular || titular.celular || '').replace(/\D/g, '');

    const payload = {
      instalacao: cpflData?.uc || '',
      instalacaoNova: cpflData?.instalacaoNova || '',
      pn: cpflData?.pn || '',
      pf_pj: isPJ ? 2 : 1,
      cnpj: isPJ ? (cpflData?.cnpj || '').replace(/\D/g, '') : '',
      inscricaoEstadual: isPJ ? (cpflData?.inscricaoEstadual || '') : '',
      nomeResponsavel: isPJ ? (cpflData?.nomeResponsavel || '') : '',
      cpfResponsavel: isPJ ? (cpflData?.cpfResponsavel || '').replace(/\D/g, '') : '',
      rgResponsavel: isPJ ? (cpflData?.rgResponsavel || '') : '',
      dataAbertura: isPJ ? formatDateToDDMMYYYY(cpflData?.dataAbertura || '') : '',
      cpf: cpfFinal,
      rg: rgFinal,
      dataNascimento: isPJ ? '' : dataNascFinal,
      telefoneFixo: telFixoFinal,
      telefoneCelular: telCelularFinal,
      email: cpflData?.email || '',
      nome: nomeFinal,
      nomeContato: cpflData?.nomeContato || titular.nome,
      cidade: cpflData?.cidade,
      uf: cpflData?.uf,
      bairro: cpflData?.bairro || '',
      logradouro: cpflData?.logradouro || '',
      numero: cpflData?.numero || '',
      cep: cpflData?.cep || '',
      complemento: cpflData?.complemento || '',
      plano: titular.plano,
      valorPlano: titular.valorPlano || cpflData?.valorPlano || '',
      dependentes: dependentes
    };

    // 🔍 Log de diagnóstico no console do navegador: mostra o payload e avisa
    // se algum campo obrigatório pela CPFL (manual 4.12) ficou vazio.
    console.log('📋 [CPFL] Payload de cadastro (Step 3 → cpfl-cadastro):', payload);
    const faltando = [];
    if (!payload.instalacao) faltando.push('Instalação (UC)');
    if (!payload.pn) faltando.push('PN');
    if (!payload.cpf || payload.cpf.length !== 11) faltando.push(`CPF inválido (${payload.cpf.length} dígitos)`);
    if (!payload.rg) faltando.push('RG');
    if (!isPJ && (!payload.dataNascimento || payload.dataNascimento.length !== 8)) faltando.push(`Data de Nascimento inválida (${payload.dataNascimento})`);
    if (!payload.telefoneFixo && !payload.telefoneCelular) faltando.push('Telefone (fixo ou celular)');
    if (isPJ) {
      if (payload.cnpj.length !== 14) faltando.push('CNPJ');
      if (!payload.inscricaoEstadual) faltando.push('Inscrição Estadual');
      if (!payload.nomeResponsavel) faltando.push('Nome do Responsável');
      if (payload.cpfResponsavel.length !== 11) faltando.push('CPF do Responsável');
      if (!payload.rgResponsavel) faltando.push('RG do Responsável');
      if (payload.dataAbertura.length !== 8) faltando.push('Data de Abertura');
    }
    if (faltando.length > 0) {
      console.warn('⚠️ [CPFL] Campos obrigatórios ausentes/inválidos — a CPFL vai rejeitar:', faltando);
    } else {
      console.log('✅ [CPFL] Todos os campos obrigatórios presentes.');
    }

    return payload;
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = { ...buildPayload(), preencherPlanilha: true, iniciarFluxoAutomatico: false };
      const token = localStorage.getItem('token');
      const response = await fetch('/api/clients/cpfl-cadastro', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (data.sucesso) {
        await salvarAnexosCadastro(data.client?.id);
        setSavedOk(true);
        setTimeout(() => {
          setSavedOk(false);
          onSave();
        }, 2000);
      } else {
        alert('Erro ao cadastrar: ' + data.mensagem);
        setSaving(false);
      }
    } catch (err) {
      alert('Erro de conexão: ' + err.message);
      setSaving(false);
    }
  };

  // Guarda os anexos do cadastro no cliente (aparecem depois no Editar).
  const salvarAnexosCadastro = async (clientId) => {
    const lista = (cpflData?.docs || []).filter((d) => d && d.file);
    if (!clientId || lista.length === 0) return;
    try {
      const token = localStorage.getItem('token');
      const salvos = [];
      for (const d of lista) {
        const fd = new FormData();
        fd.append('file', d.file);
        const resp = await axios.post('/upload', fd, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
        });
        salvos.push({ nome: d.file.name, url: resp.data.file_url, tipo: d.tipo || 'outros', enviar: d.enviar !== false });
      }
      await axios.put(`/api/clients/${clientId}`, { documents_urls: salvos }, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (err) {
      console.error('Erro ao guardar anexos do cadastro:', err);
      alert('Cliente salvo, mas houve erro ao guardar os anexos. Anexe de novo pelo Editar.');
    }
  };

  const handleSaveCharge = async () => {
    setSaving(true);
    try {
      const payload = { ...buildPayload(), preencherPlanilha: false, iniciarFluxoAutomatico: true };
      const token = localStorage.getItem('token');
      const response = await fetch('/api/clients/cpfl-cadastro', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (data.sucesso) {
        await salvarAnexosCadastro(data.client?.id);
        try {
          const clienteClicksign = {
            ...data.client,
            ...buildPayload(),
            id: data.client?.id,
            _source: 'cpfl'
          };

          const envio = await fetch('/api/clicksign/preencher-contrato-cpfl', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
              cliente: clienteClicksign,
              deliveryMethod: clienteClicksign.email ? 'email' : 'whatsapp',
              signers: [{
                name: clienteClicksign.nome || clienteClicksign.full_name || '',
                email: clienteClicksign.email || '',
                phone_number:
                  clienteClicksign.telefoneCelular ||
                  clienteClicksign.telefone_celular ||
                  '',
                cpf: clienteClicksign.cpf || '',
                birthday:
                  clienteClicksign.dataNascimento ||
                  ''
              }]
            })
          });

          const envioData = await envio.json();

          if (!envio.ok) {
            throw new Error(
              envioData.error ||
              'Falha ao enviar para o ClickSign'
            );
          }

          setSavedOk(true);

          setTimeout(() => {
            setSavedOk(false);
            onSaveAndCharge(data.client);
          }, 2000);
        } catch (envioError) {
          alert(
            `Cliente salvo, mas o envio ao ClickSign falhou: ${envioError.message}`
          );
          setSaving(false);
        }
      } else {
        alert('Erro ao cadastrar: ' + data.mensagem);
        setSaving(false);
      }
    } catch (err) {
      alert('Erro de conexão: ' + err.message);
      setSaving(false);
    }
  };

  return (
    <div className="clients-view">
      {(saving || savedOk) && (
        <div className="save-overlay">
          <div className="save-overlay-box">
            {saving && <><div className="save-spinner" /><p>Salvando cadastro...</p></>}
            {savedOk && <><div className="save-check">✓</div><p>Cadastro salvo!</p></>}
          </div>
        </div>
      )}
      <div className="step2-topbar">
        <div className="step2-topbar-left" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
          <div className="step-badge cpfl-badge"><Zap size={15} /> CPFL</div>
          <h2 className="view-title" style={{ margin: 0 }}>Cadastro de Clientes — Titular do Plano</h2>
          <p className="step-description" style={{ margin: 0 }}>Informações do titular e dependentes</p>
          <div className="step3-inline-title"><UserCheck size={16} /> <strong>Informações do Titular do Plano</strong></div>
        </div>
        <button className="back-button" style={{ margin: 0, alignSelf: 'flex-start' }} onClick={onBack}>
          <ArrowLeft size={16} /> Voltar
        </button>
      </div>
      <div className="cpfl-form-card">
        <div className="t3-row" style={{ marginBottom: 16 }}>
          {[
            ['NOME', 'nome', 'text', 'Nome completo', { flex: 1, minWidth: 220 }],
            ['CPF', 'cpf', 'text', '000.000.000-00', {}],
            ['RG', 'rg', 'text', 'RG', {}],
          ].map(([label, key, type, placeholder, style]) => (
            <div key={key} className="s2-field" style={style}>
              <label>{label}</label>
              <input type={type} value={titular[key]} onChange={e => setT(key, e.target.value)} placeholder={placeholder} />
            </div>
          ))}
          <div className="s2-field">
            <label>DATA DE NASCIMENTO</label>
            <input type="date" value={titular.dataNascimento} onChange={e => setT('dataNascimento', e.target.value)} />
          </div>
          <div className="s2-field">
            <label>ESTADO CIVIL</label>
            <select value={titular.estadoCivil} onChange={e => setT('estadoCivil', e.target.value)}>
              <option value="">Selecione</option>
              <option value="solteiro">Solteiro(a)</option>
              <option value="casado">Casado(a)</option>
              <option value="divorciado">Divorciado(a)</option>
              <option value="viuvo">Viúvo(a)</option>
              <option value="uniao">União Estável</option>
            </select>
          </div>
          <div className="s2-field">
            <label>VENDEDOR</label>
            <input type="text" value={titular.vendedor} onChange={e => setT('vendedor', e.target.value)} placeholder="Nome do vendedor" />
          </div>
          <div className="s2-field">
            <label>Plano</label>
            <select value={titular.plano} onChange={e => setT('plano', e.target.value)}>
              <option value="">Selecione</option>
              <option value="Humano">Humano</option>
              <option value="Pet">Pet</option>
              <option value="Humano + Pet">Humano + Pet</option>
            </select>
          </div>
          <div className="s2-field">
            <label>VALOR DO PLANO</label>
            <input
              type="text"
              value={titular.valorPlano}
              onChange={e => setT('valorPlano', e.target.value)}
              placeholder="Ex.: 99,90"
            />
          </div>

          <div className="s2-field">
            <label>TELEFONE</label>
            <input
              type="text"
              value={titular.telefone}
              onChange={e => setT('telefone', e.target.value)}
              placeholder="(00) 0000-0000"
            />
          </div>
          <div className="s2-field">
            <label>CELULAR</label>
            <input type="text" value={titular.celular} onChange={e => setT('celular', e.target.value)} placeholder="(00) 00000-0000" />
          </div>
        </div>
      </div>
      <div className="step3-section">
        <div className="step3-section-title"><Users size={18} /> Dependentes</div>
        <div className="cpfl-form-card" style={{ marginTop: 0 }}>
          <div className="dep-add-row">
            <div className="s2-field" style={{ flex: 1, minWidth: 220 }}>
              <label>NOME COMPLETO</label>
              <input type="text" value={depForm.nome} onChange={e => setD('nome', e.target.value)} placeholder="Nome completo do dependente" />
            </div>
            <div className="s2-field" style={{ width: 160, flexShrink: 0 }}>
              <label>DATA DE NASCIMENTO</label>
              <input type="date" value={depForm.dataNascimento} onChange={e => setD('dataNascimento', e.target.value)} />
            </div>
            <div className="s2-field" style={{ width: 180, flexShrink: 0 }}>
              <label>GRAU DE PARENTESCO</label>
              <select value={depForm.grau} onChange={e => setD('grau', e.target.value)}>
                <option value="filho">Filho(a)</option>
                <option value="conjuge">Cônjuge</option>
                <option value="pai">Pai / Mãe</option>
                <option value="agregado">Agregado</option>
              </select>
            </div>
            <button className="btn-add-dep" onClick={addDependente}><Plus size={16} /> Adicionar</button>
          </div>
          {dependentes.length > 0 && (
            <div className="dep-table-wrapper">
              <table className="dep-table">
                <thead>
                  <tr><th>#</th><th>Nome</th><th>Nascimento</th><th>Grau</th><th>Opções</th></tr>
                </thead>
                <tbody>
                  {dependentes.map((d, i) => (
                    <tr key={d.id} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                      <td className="dep-num">{i + 1}</td>
                      <td className="dep-nome">
                        <div className="td-name-inner">
                          <div className="mini-avatar dep-avatar">{d.nome.charAt(0)}</div>
                          {d.nome.toUpperCase()}
                        </div>
                      </td>
                      <td className="dep-nasc">
                        {calcIdade(d.dataNascimento)}{' '}
                        {d.dataNascimento ? new Date(d.dataNascimento + 'T00:00:00').toLocaleDateString('pt-BR') : '—'}
                      </td>
                      <td><span className={`grau-badge grau-${d.grau}`}>{grauLabels[d.grau]}</span></td>
                      <td>
                        <button className="btn-dep-action excluir" onClick={() => removeDep(d.id)}>
                          <Trash2 size={13} /> Excluir
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <div className="final-actions">
        <button className="btn-cancel-edit" onClick={onBack}>Cancelar</button>
        <button className="btn-save-only" onClick={handleSave}>💾 Salvar Cadastro</button>
        <button className="btn-save-charge" onClick={handleSaveCharge}>⚡ Salvar e Gerar Cobrança</button>
      </div>
    </div>
  );
}

// ── PASSO 3 ASAAS ────────────────────────────────────────────────────────────
function AsaasStep3({ asaasData, onBack, onSave, onSaveAndCharge }) {
  const [saving, setSaving] = useState(false);
  const [savedOk, setSavedOk] = useState(false);
  const [plano, setPlano] = useState('');
  const [vendedor, setVendedor] = useState('');

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => { setSaving(false); setSavedOk(true); }, 1400);
    setTimeout(() => { setSavedOk(false); onSave(); }, 2600);
  };
  const handleSaveCharge = () => {
    setSaving(true);
    setTimeout(() => { setSaving(false); setSavedOk(true); }, 1400);
    setTimeout(() => { setSavedOk(false); onSaveAndCharge({ ...asaasData, plano, vendedor }); }, 2600);
  };

  return (
    <div className="clients-view">
      {(saving || savedOk) && (
        <div className="save-overlay">
          <div className="save-overlay-box">
            {saving && <><div className="save-spinner" /><p>Salvando cadastro...</p></>}
            {savedOk && <><div className="save-check">✓</div><p>Cadastro salvo!</p></>}
          </div>
        </div>
      )}
      <div className="step2-topbar">
        <div className="step2-topbar-left" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
          <div className="step-badge asaas-badge"><CreditCard size={15} /> Asaas</div>
          <h2 className="view-title" style={{ margin: 0 }}>Cadastro Asaas — Confirmação</h2>
          <p className="step-description" style={{ margin: 0 }}>Cliente cadastrado com sucesso no Asaas. Complete o plano.</p>
        </div>
        <button className="back-button" style={{ margin: 0, alignSelf: 'flex-start' }} onClick={onBack}>
          <ArrowLeft size={16} /> Voltar
        </button>
      </div>

      <div className="cpfl-form-card">
        <div className="asaas-confirm-box">
          <div className="asaas-confirm-icon">✓</div>
          <div className="asaas-confirm-info">
            <strong>{asaasData?.name}</strong>
            <span>ID Asaas: {asaasData?.asaasId}</span>
            <span>{asaasData?.cpfCnpj} · {asaasData?.email || '—'}</span>
          </div>
        </div>

        <div className="cpfl-divider" />

        <div className="asaas-grid-2" style={{ maxWidth: 500 }}>
          <div className="s2-field">
            <label>PLANO</label>
            <select value={plano} onChange={e => setPlano(e.target.value)}>
              <option value="">Selecione</option>
              <option value="Humano">Humano</option>
              <option value="Pet">Pet</option>
              <option value="Humano + Pet">Humano + Pet</option>
            </select>
          </div>
          <div className="s2-field">
            <label>VENDEDOR</label>
            <input
              type="text"
              value={vendedor}
              onChange={e => setVendedor(e.target.value)}
              placeholder="Nome do vendedor"
            />
          </div>
        </div>

        <div className="cpfl-actions">
          <button className="btn-cancel-edit" onClick={onBack}>Cancelar</button>
          <button className="btn-save-only" onClick={handleSave}>💾 Salvar Cadastro</button>
          <button className="btn-save-charge" onClick={handleSaveCharge}>⚡ Salvar e Gerar Cobrança</button>
        </div>
      </div>
    </div>
  );
}

// ── DETALHE DO CLIENTE ───────────────────────────────────────────────────────
// ── DETALHE DO CLIENTE ───────────────────────────────────────────────────────
function ClientDetail({ client, onBack, onEdit, onGerarCobranca }) {
  const isAsaas = client._source === 'asaas';

  const calcularIdade = (dataStr) => {
    if (!dataStr) return null;
    const nasc = new Date(String(dataStr).slice(0, 10) + 'T00:00:00');
    if (isNaN(nasc.getTime())) return null;
    const hoje = new Date();
    let idade = hoje.getFullYear() - nasc.getFullYear();
    const m = hoje.getMonth() - nasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;
    return idade;
  };

  const formatarData = (dataStr) => {
    if (!dataStr) return '—';
    const [ano, mes, dia] = String(dataStr).slice(0, 10).split('-');
    if (!ano || !mes || !dia) return dataStr;
    return `${dia}/${mes}/${ano}`;
  };

  if (isAsaas) {
    return (
      <div className="clients-view">
        <button className="back-button" onClick={onBack}><ArrowLeft size={18} /> Voltar</button>
        <div className="profile-header">
          <div className="profile-avatar">{client.name?.charAt(0)}</div>
          <div className="profile-info">
            <h2>{client.name}</h2>
            <div className="profile-badges">
              <span className="type-badge type-asaas">ASAAS</span>
              <span className={`status-badge status-${client.deleted ? 'inativo' : 'ativo'}`}>{client.deleted ? 'Inativo' : 'Ativo'}</span>
            </div>
          </div>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
            <button className="btn-secondary-modern" onClick={() => onEdit(client)}>Editar Dados</button>
            <button className="btn-primary-modern" onClick={() => onGerarCobranca(client)}>Gerar Cobrança</button>
          </div>
        </div>
        <div className="client-sheet">
          <div className="sheet-section">
            <div className="sheet-section-title">Dados Pessoais</div>
            <div className="info-grid">
              <div className="info-item"><span className="info-label">CPF/CNPJ</span><span className="info-value">{client.cpfCnpj || '—'}</span></div>
              <div className="info-item"><span className="info-label">ID Asaas</span><span className="info-value">{client.id || '—'}</span></div>
            </div>
          </div>
          <div className="sheet-section">
            <div className="sheet-section-title">Contato e Endereço</div>
            <div className="info-grid">
              <div className="info-item"><span className="info-label">Telefone</span><span className="info-value">{client.phone || client.mobilePhone || '—'}</span></div>
              <div className="info-item"><span className="info-label">E-mail</span><span className="info-value">{client.email || '—'}</span></div>
              <div className="info-item" style={{ gridColumn: 'span 2' }}><span className="info-label">Endereço</span><span className="info-value">{client.address || '—'}</span></div>
              <div className="info-item"><span className="info-label">Cidade/UF</span><span className="info-value">{client.cityName || '—'} / {client.state || '—'}</span></div>
              <div className="info-item"><span className="info-label">CEP</span><span className="info-value">{client.postalCode || '—'}</span></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const IV = ({ label, value }) => (
    <div className="info-item"><span className="info-label">{label}</span><span className="info-value">{value || '—'}</span></div>
  );

  return (
    <div className="clients-view clients-view-wide">
      <button className="back-button" onClick={onBack}><ArrowLeft size={18} /> Voltar</button>

      <div className="profile-header">
        <div className="profile-avatar">{(client.titular_plano_nome || client.full_name)?.charAt(0)}</div>
        <div className="profile-info">
          <h2>{client.titular_plano_nome || client.full_name}</h2>
          <div className="profile-badges">
            <span className="type-badge type-cpfl">CPFL</span>
            <span className={`status-badge status-${(client.status || 'ativo').toLowerCase()}`}>{client.status || 'Ativo'}</span>
          </div>
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
          <button className="btn-secondary-modern" onClick={() => onEdit(client)}>Editar Dados</button>
          <button className="btn-primary-modern" onClick={() => onGerarCobranca(client)}>Gerar Cobrança</button>
        </div>
      </div>

      <div className="titular-resp-grid">
        {/* ── TITULAR ── */}
        <div className="tr-panel">
          <div className="tr-panel-header">Titular</div>

          {/* MD3 */}
          <div className="tr-row">
            <IV label="Matrícula / ID" value={client.cpfl_installation_number || client.id} />
          </div>
          <div className="tr-row">
            <IV label="CPF" value={client.titular_plano_cpf || client.cpf} />
            <IV label="Nome completo" value={client.titular_plano_nome || client.full_name} />
          </div>
          <div className="tr-row">
            <IV label="RG" value={client.titular_plano_rg} />
            <IV label="Data de Nascimento" value={formatarData(client.titular_plano_nascimento)} />
            <IV label="Estado civil" value={client.titular_plano_estado_civil} />
          </div>
          <div className="tr-row">
            <IV label="Vendedor" value={client.titular_plano_vendedor} />
            <IV label="Data do cadastro" value={formatarData(client.created_date)} />
            <IV label="Nacionalidade" value={client.titular_plano_nacionalidade} />
          </div>
          <div className="tr-row">
            <IV label="E-mail" value={client.email} />
            <IV label="Profissão" value={client.titular_plano_profissao} />
            <IV label="Empresa" value={client.titular_plano_empresa} />
          </div>
          <div className="tr-row">
            <IV label="Logradouro" value={client.logradouro} />
            <IV label="Número" value={client.numero} />
          </div>
          <div className="tr-row">
            <IV label="Complemento" value={client.complemento} />
            <IV label="Bairro" value={client.bairro} />
          </div>
          <div className="tr-row">
            <IV label="Cidade" value={client.city} />
            <IV label="Estado" value={client.state} />
            <IV label="CEP" value={client.zip_code} />
          </div>
          <div className="tr-row">
            <IV label="Telefone" value={client.titular_plano_telefone} />
            <IV label="Celular" value={client.titular_plano_celular || client.phone} />
            <IV label="Outros Telefones" value={client.titular_plano_outros_telefones} />
          </div>

          {client.documents_urls?.length > 0 && (
            <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #f1f5f9' }}>
              <div className="info-label" style={{ marginBottom: 10 }}>Documentos Anexados</div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {client.documents_urls.map((doc, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0' }}>
                    <FileText size={15} style={{ color: '#e11d48', flexShrink: 0 }} />
                    <a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ color: '#4f46e5', fontSize: 13, textDecoration: 'underline' }}>
                      {doc.nome || 'Documento'}
                    </a>
                    {doc.tipo && <span style={{ fontSize: 12, color: '#94a3b8' }}>({doc.tipo})</span>}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* ── RESPONSÁVEL CPFL ── */}
        <div className="tr-panel">
          <div className="tr-panel-header">Responsável CPFL</div>

          <div className="tr-row">
            <IV label="CPF do Responsável" value={client.cpf} />
            <IV label="Nome do Responsável" value={client.nome_contato || client.full_name} />
          </div>
          <div className="tr-row">
            <IV label="RG do Responsável" value={client.rg} />
            <IV label="Data de Nasc. do Responsável" value={formatarData(client.birth_date)} />
            <IV label="Tel. do Responsável" value={client.telefone_contato} />
          </div>
          <div className="tr-row">
            <IV label="UC/Instalação" value={client.cpfl_installation_number} />
            <IV label="Instalação Nova" value={client.instalacao_nova} />
            <IV label="Parceiro de Negócio (PN)" value={client.cpfl_account_number} />
          </div>
          <div className="tr-row">
            <IV label="Plano" value={client.plan_name} />
            <IV label="Status" value={client.status} />
          </div>

          <div className="tr-panel-header" style={{ marginTop: 20 }}>Dependentes</div>
          {Array.isArray(client.dependents) && client.dependents.length > 0 ? (
            <table className="dep-table-v2">
              <thead>
                <tr><th>#</th><th>Nome</th><th>Nascimento</th><th>Grau</th></tr>
              </thead>
              <tbody>
                {client.dependents.map((dep, i) => {
                  const idade = calcularIdade(dep.dataNascimento);
                  const maiorDeIdade = idade !== null && idade > 21;
                  return (
                    <tr key={i} className={maiorDeIdade ? 'dep-row-maior21' : ''}>
                      <td>{i + 1}</td>
                      <td>{dep.nome || '—'}</td>
                      <td>{idade !== null ? `(${idade}) ` : ''}{formatarData(dep.dataNascimento)}</td>
                      <td>{dep.grau || '—'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="info-value" style={{ color: '#94a3b8', padding: '10px 0', fontWeight: 400 }}>Nenhum dependente cadastrado.</div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── EDIÇÃO DO CLIENTE ────────────────────────────────────────────────────────
function ClientEdit({ client, onBack, onSave }) {
  const isAsaas = client._source === 'asaas' || client._source === 'celcoin';

  const [form, setForm] = useState(() => {
    if (isAsaas) {
      return {
        name: client.name || '',
        cpfCnpj: client.cpfCnpj || '',
        email: client.email || '',
        phone: client.phone || '',
        mobilePhone: client.mobilePhone || '',
        city: client.cityName || '',
        state: client.state || '',
        address: client.address || '',
        addressNumber: client.addressNumber || '',
        complement: client.complement || '',
        province: client.province || '',
        postalCode: client.postalCode || '',
        plan_name: client.plan_name || '',
        vendedor: client.vendedor || '',
        status: client.deleted ? 'inativo' : 'ativo'
      };
    }
    return {
      titular_plano_cpf: client.titular_plano_cpf || client.cpf || '',
      titular_plano_nome: client.titular_plano_nome || client.full_name || '',
      titular_plano_rg: client.titular_plano_rg || '',
      titular_plano_nascimento: client.titular_plano_nascimento || '',
      titular_plano_estado_civil: client.titular_plano_estado_civil || '',
      titular_plano_vendedor: client.titular_plano_vendedor || '',
      titular_plano_nacionalidade: client.titular_plano_nacionalidade || '',
      titular_plano_profissao: client.titular_plano_profissao || '',
      titular_plano_empresa: client.titular_plano_empresa || '',
      email: client.email || '',
      bairro: client.bairro || '',
      logradouro: client.logradouro || '',
      numero: client.numero || '',
      complemento: client.complemento || '',
      city: client.city || '',
      state: client.state || '',
      zip_code: client.zip_code || '',
      titular_plano_telefone: client.titular_plano_telefone || '',
      titular_plano_celular: client.titular_plano_celular || client.phone || '',
      titular_plano_outros_telefones: client.titular_plano_outros_telefones || '',
      cpf: client.cpf || '',
      nome_contato: client.nome_contato || '',
      rg: client.rg || '',
      birth_date: client.birth_date || '',
      telefone_contato: client.telefone_contato || '',
      cpfl_installation_number: client.cpfl_installation_number || '',
      instalacao_nova: client.instalacao_nova || '',
      cpfl_account_number: client.cpfl_account_number || '',
      full_name: client.full_name || '',
      nome_conjuge: client.nome_conjuge || '',
      cpf_conjuge: client.cpf_conjuge || '',
      rg_conjuge: client.rg_conjuge || '',
      plan_name: client.plan_name || '',
      status: client.status || 'ativo',
    };
  });

  const [dependentes, setDependentes] = useState(Array.isArray(client.dependents) ? client.dependents : []);
  const [depForm, setDepForm] = useState({ nome: '', dataNascimento: '', grau: 'Filhos' });
  const [depEditIndex, setDepEditIndex] = useState(null);

  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [documentos, setDocumentos] = useState(client.documents_urls || []);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const calcularIdade = (dataStr) => {
    if (!dataStr) return null;
    const nasc = new Date(dataStr + 'T00:00:00');
    if (isNaN(nasc.getTime())) return null;
    const hoje = new Date();
    let idade = hoje.getFullYear() - nasc.getFullYear();
    const m = hoje.getMonth() - nasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;
    return idade;
  };

  const handleDepChange = (e) => {
    const { name, value } = e.target;
    setDepForm(prev => ({ ...prev, [name]: value }));
  };

  const handleAddOrUpdateDep = () => {
    if (!depForm.nome.trim()) {
      alert('Informe o nome do dependente.');
      return;
    }
    if (depEditIndex !== null) {
      setDependentes(prev => prev.map((d, i) => (i === depEditIndex ? { ...depForm } : d)));
      setDepEditIndex(null);
    } else {
      setDependentes(prev => [...prev, { ...depForm }]);
    }
    setDepForm({ nome: '', dataNascimento: '', grau: 'Filhos' });
  };

  const handleEditDep = (idx) => {
    setDepForm(dependentes[idx]);
    setDepEditIndex(idx);
  };

  const handleRemoveDep = (idx) => {
    setDependentes(prev => prev.filter((_, i) => i !== idx));
    if (depEditIndex === idx) {
      setDepEditIndex(null);
      setDepForm({ nome: '', dataNascimento: '', grau: 'Filhos' });
    }
  };

  const handleUploadDoc = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setUploading(true);
    try {
      const token = localStorage.getItem('token');
      const novosUrls = [];
      for (const file of files) {
        const formData = new FormData();
        formData.append('file', file);
        const resp = await axios.post('/upload', formData, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
        });
        novosUrls.push({ nome: file.name, url: resp.data.file_url, tipo: 'outros', enviar: true });
      }
      setDocumentos(prev => [...prev, ...novosUrls]);
    } catch (err) {
      console.error(err);
      alert('Erro ao enviar arquivo. Tente novamente.');
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const handleRemoveDoc = (idx) => {
    setDocumentos(prev => prev.filter((_, i) => i !== idx));
  };

  const handleDocTipoChange = (idx, tipo) => {
    setDocumentos(prev => prev.map((d, i) => (i === idx ? { ...d, tipo } : d)));
  };

  const handleDocEnviarChange = (idx, enviar) => {
    setDocumentos(prev => prev.map((d, i) => (i === idx ? { ...d, enviar } : d)));
  };

  // Garante que campos de data só vão pro backend em AAAA-MM-DD válido ou
  // vazio — evita erro de banco (ex: string "Invalid date" acabando em uma
  // coluna DATEONLY do Postgres).
  const sanitizeDateFields = (obj, fields) => {
    const clean = { ...obj };
    fields.forEach((f) => {
      const v = clean[f];
      if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        clean[f] = null;
      }
    });
    return clean;
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      let dataToSave = isAsaas
        ? form
        : { ...form, dependents: dependentes, documents_urls: documentos };
      if (!isAsaas) {
        dataToSave = sanitizeDateFields(dataToSave, ['titular_plano_nascimento', 'birth_date']);
      }
      if (!isAsaas && dataToSave.plan_value !== undefined) {
        const n = parseFloat(String(dataToSave.plan_value).replace(',', '.'));
        dataToSave = { ...dataToSave, plan_value: Number.isFinite(n) ? n : null };
      }
      await onSave(dataToSave);
      setSaved(true);
      setTimeout(() => {
        setSaved(false);
        onBack();
      }, 1500);
    } catch (err) {
      console.error(err);
      alert('Erro ao salvar. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  if (isAsaas) {
    return (
      <div className="clients-view clients-view-wide">
        <button className="back-button" onClick={onBack}><ArrowLeft size={18} /> Voltar</button>
        <h2 className="view-title" style={{ marginBottom: 12 }}>Editar Cliente</h2>
        {saved && <div className="alert-success">✅ Dados salvos!</div>}

        <div className="titular-resp-grid">
          <div className="tr-panel">
            <div className="tr-panel-header">Responsável {client._source === 'celcoin' ? 'Celcoin' : 'Asaas'}</div>

            {/* MD3 */}
            <div className="tr-row">
              <div className="edit-field">
                <label>Matrícula / ID</label>
                <input type="text" value={client.id || ''} readOnly disabled title="Somente leitura" style={{ background: '#f1f5f9', color: '#475569' }} />
              </div>
            </div>
            <div className="tr-row">
              <div className="edit-field"><label>Nome *</label><input type="text" name="name" value={form.name} onChange={handleChange} required /></div>
              <div className="edit-field"><label>CPF/CNPJ *</label><input type="text" name="cpfCnpj" value={form.cpfCnpj} onChange={handleChange} required /></div>
            </div>
            <div className="tr-row">
              <div className="edit-field"><label>E-mail</label><input type="email" name="email" value={form.email} onChange={handleChange} /></div>
              <div className="edit-field"><label>Telefone</label><input type="text" name="phone" value={form.phone} onChange={handleChange} /></div>
              <div className="edit-field"><label>Celular</label><input type="text" name="mobilePhone" value={form.mobilePhone} onChange={handleChange} /></div>
            </div>
            <div className="tr-row">
              <div className="edit-field"><label>Plano</label>
                <select name="plan_name" value={form.plan_name} onChange={handleChange}>
                  <option value="">Selecione</option>
                  <option value="Humano">Humano</option>
                  <option value="Pet">Pet</option>
                  <option value="Humano + Pet">Humano + Pet</option>
                </select>
              </div>
              <div className="edit-field"><label>Vendedor</label><input type="text" name="vendedor" value={form.vendedor} onChange={handleChange} /></div>
              <div className="edit-field">
                <label>Status</label>
                <select name="status" value={form.status} onChange={handleChange}>
                  <option value="ativo">Ativo</option>
                  <option value="inativo">Inativo</option>
                </select>
              </div>
            </div>
            <div className="tr-row">
              <div className="edit-field"><label>Endereço</label><input type="text" name="address" value={form.address} onChange={handleChange} /></div>
              <div className="edit-field"><label>Número</label><input type="text" name="addressNumber" value={form.addressNumber} onChange={handleChange} /></div>
            </div>
            <div className="tr-row">
              <div className="edit-field"><label>Complemento</label><input type="text" name="complement" value={form.complement} onChange={handleChange} /></div>
              <div className="edit-field"><label>Bairro</label><input type="text" name="province" value={form.province} onChange={handleChange} /></div>
            </div>
            <div className="tr-row">
              <div className="edit-field"><label>Cidade</label><input type="text" name="city" value={form.city} onChange={handleChange} /></div>
              <div className="edit-field"><label>Estado (UF)</label><input type="text" name="state" value={form.state} onChange={handleChange} maxLength="2" /></div>
              <div className="edit-field"><label>CEP</label><input type="text" name="postalCode" value={form.postalCode} onChange={handleChange} /></div>
            </div>
          </div>
          <div className="tr-panel">
            <div className="tr-panel-header">Dependentes</div>
            <div className="tr-row">
              <div className="edit-field"><label>Nome completo</label><input type="text" name="nome" value={depForm.nome} onChange={handleDepChange} placeholder="Ex: João da Silva" /></div>
              <div className="edit-field"><label>Data de Nascimento</label><DataBRInput value={depForm.dataNascimento} onChange={(iso) => setDepForm(prev => ({ ...prev, dataNascimento: iso }))} /></div>
            </div>
            <div className="tr-row">
              <div className="edit-field">
                <label>Grau de parentesco</label>
                <select name="grau" value={depForm.grau} onChange={handleDepChange}>
                  <option value="Filhos">Filhos</option>
                  <option value="Cônjuge">Cônjuge</option>
                  <option value="Pais">Pais</option>
                  <option value="Outros">Outros</option>
                </select>
              </div>
              <div className="edit-field" style={{ justifyContent: 'flex-end' }}>
                <label>&nbsp;</label>
                <button type="button" className="btn-save-edit" onClick={handleAddOrUpdateDep}>
                  {depEditIndex !== null ? 'Atualizar' : '+ Adicionar'}
                </button>
              </div>
            </div>
            {dependentes.length > 0 && (
              <table className="dep-table-v2">
                <thead>
                  <tr><th>#</th><th>Nome</th><th>Nascimento</th><th>Grau</th><th>Opções</th></tr>
                </thead>
                <tbody>
                  {dependentes.map((dep, i) => {
                    const idade = calcularIdade(dep.dataNascimento);
                    const maiorDeIdade = idade !== null && idade > 21;
                    return (
                      <tr key={i} className={maiorDeIdade ? 'dep-row-maior21' : ''}>
                        <td>{i + 1}</td>
                        <td>{dep.nome || '—'}</td>
                        <td>{idade !== null ? `(${idade}) ` : ''}{dep.dataNascimento ? dep.dataNascimento.split('-').reverse().join('/') : '—'}</td>
                        <td>{dep.grau || '—'}</td>
                        <td>
                          <button type="button" onClick={() => handleEditDep(i)} title="Editar" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#4f46e5', marginRight: 6 }}>
                            <Pencil size={14} />
                          </button>
                          <button type="button" onClick={() => handleRemoveDep(i)} title="Excluir" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444' }}>
                            <Trash2 size={14} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <div style={{ display: 'flex', gap: 16, marginTop: 10, fontSize: 12, color: '#64748b' }}>
              <span><span style={{ display: 'inline-block', width: 12, height: 12, background: '#fecaca', borderRadius: 3, marginRight: 4, verticalAlign: 'middle' }} /> Maior 21</span>
            </div>
          </div>
        </div>

        <div className="edit-actions">
          <button className="btn-cancel-edit" onClick={onBack}>Cancelar</button>
          <button className="btn-save-edit" onClick={handleSave} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="clients-view clients-view-wide">
      <button className="back-button" onClick={onBack}><ArrowLeft size={18} /> Voltar</button>
      <h2 className="view-title" style={{ marginBottom: 12 }}>Editar Cliente</h2>
      {saved && <div className="alert-success">✅ Dados salvos!</div>}

      <div className="titular-resp-grid">
        {/* ── TITULAR ── */}
        <div className="tr-panel">
          <div className="tr-panel-header">Titular</div>

          {/* MD3 */}
          <div className="tr-row">
            <div className="edit-field">
              <label>Matrícula / ID</label>
              <input type="text" value={form.cpfl_installation_number || client.id || ''} readOnly disabled title="Somente leitura" style={{ background: '#f1f5f9', color: '#475569' }} />
            </div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>CPF</label><input type="text" name="titular_plano_cpf" value={form.titular_plano_cpf} onChange={handleChange} /></div>
            <div className="edit-field"><label>Nome completo</label><input type="text" name="titular_plano_nome" value={form.titular_plano_nome} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>RG</label><input type="text" name="titular_plano_rg" value={form.titular_plano_rg} onChange={handleChange} /></div>
            <div className="edit-field"><label>Data de Nascimento</label><DataBRInput value={form.titular_plano_nascimento} onChange={(iso) => setForm(prev => ({ ...prev, titular_plano_nascimento: iso }))} /></div>
            <div className="edit-field">
              <label>Estado civil</label>
              <select name="titular_plano_estado_civil" value={form.titular_plano_estado_civil} onChange={handleChange}>
                <option value="">Selecione</option>
                <option value="Solteiro(a)">Solteiro(a)</option>
                <option value="Casado(a)">Casado(a)</option>
                <option value="Divorciado(a)">Divorciado(a)</option>
                <option value="Viúvo(a)">Viúvo(a)</option>
                <option value="União Estável">União Estável</option>
              </select>
            </div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>Vendedor</label><input type="text" name="titular_plano_vendedor" value={form.titular_plano_vendedor} onChange={handleChange} /></div>
            <div className="edit-field"><label>Data do cadastro</label><input type="text" value={client.created_date ? String(client.created_date).slice(0,10).split('-').reverse().join('/') : '—'} disabled /></div>
            <div className="edit-field"><label>Nacionalidade</label><input type="text" name="titular_plano_nacionalidade" value={form.titular_plano_nacionalidade} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>E-mail</label><input type="email" name="email" value={form.email} onChange={handleChange} /></div>
            <div className="edit-field"><label>Profissão</label><input type="text" name="titular_plano_profissao" value={form.titular_plano_profissao} onChange={handleChange} /></div>
            <div className="edit-field"><label>Empresa</label><input type="text" name="titular_plano_empresa" value={form.titular_plano_empresa} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>Logradouro</label><input type="text" name="logradouro" value={form.logradouro} onChange={handleChange} /></div>
            <div className="edit-field"><label>Número</label><input type="text" name="numero" value={form.numero} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>Complemento</label><input type="text" name="complemento" value={form.complemento} onChange={handleChange} /></div>
            <div className="edit-field"><label>Bairro</label><input type="text" name="bairro" value={form.bairro} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>Cidade</label><input type="text" name="city" value={form.city} onChange={handleChange} /></div>
            <div className="edit-field"><label>Estado</label><input type="text" name="state" value={form.state} onChange={handleChange} maxLength="2" /></div>
            <div className="edit-field"><label>CEP</label><input type="text" name="zip_code" value={form.zip_code} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>Telefone</label><input type="text" name="titular_plano_telefone" value={form.titular_plano_telefone} onChange={handleChange} /></div>
            <div className="edit-field"><label>Celular</label><input type="text" name="titular_plano_celular" value={form.titular_plano_celular} onChange={handleChange} /></div>
            <div className="edit-field"><label>Outros Telefones</label><input type="text" name="titular_plano_outros_telefones" value={form.titular_plano_outros_telefones} onChange={handleChange} /></div>
          </div>

          <div style={{ marginTop: 16, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            <input type="file" multiple ref={fileInputRef} style={{ display: 'none' }} onChange={handleUploadDoc} accept=".jpg,.jpeg,.png,.gif,.pdf,.xlsx,.xls,.csv,.doc,.docx" />
            <button type="button" className="btn-anexar" onClick={() => fileInputRef.current.click()} disabled={uploading}>
              <CloudUpload size={17} /> {uploading ? 'Enviando...' : 'Anexar Documentos'}
            </button>
            {!isAsaas && <AnexosCpflButton instalacao={form.cpfl_installation_number} />}
          </div>
          <div>
            {documentos.length > 0 && (
              <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {documentos.map((doc, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, flexWrap: 'nowrap', minHeight: 0 }}>
                    <a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 13, color: '#4f46e5', textDecoration: 'underline', flex: '1 1 140px', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {doc.nome || doc.url}
                    </a>
                    <select
                      value={doc.tipo || 'outros'}
                      onChange={(e) => handleDocTipoChange(i, e.target.value)}
                      style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13, flexShrink: 0, width: 'auto', margin: 0 }}
                    >
                      <option value="contrato">Contrato</option>
                      <option value="autorizacao">Autorização</option>
                      <option value="outros">Outros</option>
                    </select>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer', flexShrink: 0, width: 'auto', margin: 0 }}>
                      <input type="checkbox" style={{ width: 'auto', margin: 0 }} checked={doc.enviar !== false} onChange={(e) => handleDocEnviarChange(i, e.target.checked)} />
                      Enviar
                    </label>
                    <button type="button" onClick={() => handleRemoveDoc(i)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', flex: '0 0 auto', width: 'auto', minWidth: 0, height: 'auto', margin: 0, padding: 4, display: 'inline-flex', alignItems: 'center' }}>
                      <Trash2 size={14} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ── RESPONSÁVEL CPFL ── */}
        <div className="tr-panel">
          <div className="tr-panel-header">Responsável CPFL</div>

          <div className="tr-row">
            <div className="edit-field"><label>CPF do Responsável</label><input type="text" name="cpf" value={form.cpf} onChange={handleChange} /></div>
            <div className="edit-field"><label>Nome do Responsável</label><input type="text" name="nome_contato" value={form.nome_contato} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>RG do Responsável</label><input type="text" name="rg" value={form.rg} onChange={handleChange} /></div>
            <div className="edit-field"><label>Data de Nasc. do Responsável</label><DataBRInput value={form.birth_date} onChange={(iso) => setForm(prev => ({ ...prev, birth_date: iso }))} /></div>
            <div className="edit-field"><label>Tel. do Responsável</label><input type="text" name="telefone_contato" value={form.telefone_contato} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>UC/Instalação</label><input type="text" name="cpfl_installation_number" value={form.cpfl_installation_number} onChange={handleChange} /></div>
            <div className="edit-field"><label>Instalação Nova</label><input type="text" name="instalacao_nova" value={form.instalacao_nova} onChange={handleChange} placeholder="Ex: XXX" /></div>
            <div className="edit-field"><label>Parceiro de Negócio (PN)</label><input type="text" name="cpfl_account_number" value={form.cpfl_account_number} onChange={handleChange} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field"><label>Plano</label><input type="text" name="plan_name" value={form.plan_name} onChange={handleChange} /></div>
            <div className="edit-field"><label>Valor (R$)</label><input type="text" inputMode="decimal" placeholder="0,00" name="plan_value" value={String(form.plan_value ?? client.plan_value ?? '').replace('.', ',')} onChange={(e) => setForm(prev => ({ ...prev, plan_value: e.target.value.replace(/[^\d.,]/g, '') }))} /></div>
            <div className="edit-field">
              <label>Status</label>
              <select name="status" value={form.status} onChange={handleChange}>
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </select>
            </div>
          </div>

          <div className="tr-panel-header" style={{ marginTop: 20 }}>Dependentes</div>
          <div className="tr-row">
            <div className="edit-field"><label>Nome completo</label><input type="text" name="nome" value={depForm.nome} onChange={handleDepChange} placeholder="Ex: João da Silva" /></div>
            <div className="edit-field"><label>Data de Nascimento</label><DataBRInput value={depForm.dataNascimento} onChange={(iso) => setDepForm(prev => ({ ...prev, dataNascimento: iso }))} /></div>
          </div>
          <div className="tr-row">
            <div className="edit-field">
              <label>Grau de parentesco</label>
              <select name="grau" value={depForm.grau} onChange={handleDepChange}>
                <option value="Filhos">Filhos</option>
                <option value="Cônjuge">Cônjuge</option>
                <option value="Pais">Pais</option>
                <option value="Outros">Outros</option>
              </select>
            </div>
            <div className="edit-field" style={{ justifyContent: 'flex-end' }}>
              <label>&nbsp;</label>
              <button type="button" className="btn-save-edit" onClick={handleAddOrUpdateDep}>
                {depEditIndex !== null ? 'Atualizar' : '+ Adicionar'}
              </button>
            </div>
          </div>

          {dependentes.length > 0 && (
            <table className="dep-table-v2">
              <thead>
                <tr><th>#</th><th>Nome</th><th>Nascimento</th><th>Grau</th><th>Opções</th></tr>
              </thead>
              <tbody>
                {dependentes.map((dep, i) => {
                  const idade = calcularIdade(dep.dataNascimento);
                  const maiorDeIdade = idade !== null && idade > 21;
                  return (
                    <tr key={i} className={maiorDeIdade ? 'dep-row-maior21' : ''}>
                      <td>{i + 1}</td>
                      <td>{dep.nome || '—'}</td>
                      <td>{idade !== null ? `(${idade}) ` : ''}{dep.dataNascimento ? dep.dataNascimento.split('-').reverse().join('/') : '—'}</td>
                      <td>{dep.grau || '—'}</td>
                      <td className="dep-opcoes-td">
                        <div className="dep-opcoes">
                          <button type="button" className="dep-btn-icone" onClick={() => handleEditDep(i)} title="Editar" style={{ color: '#4f46e5' }}>
                            <Pencil size={14} />
                          </button>
                          <button type="button" className="dep-btn-icone" onClick={() => handleRemoveDep(i)} title="Excluir" style={{ color: '#ef4444' }}>
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <div style={{ display: 'flex', gap: 16, marginTop: 10, fontSize: 12, color: '#64748b' }}>
            <span><span style={{ display: 'inline-block', width: 12, height: 12, background: '#fecaca', borderRadius: 3, marginRight: 4, verticalAlign: 'middle' }} /> Maior 21</span>
          </div>
        </div>
      </div>

      <div className="edit-actions">
        <button className="btn-cancel-edit" onClick={onBack}>Cancelar</button>
        <button className="btn-save-edit" onClick={handleSave} disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar'}
        </button>
      </div>
    </div>
  );
}

// ── CARTEIRINHA ──────────────────────────────────────────────────────────────
const mockDependentes = {};

function CarteirinhaCard({ nome, matricula, nascimento, cidade, isDep, grau, modeloUrl }) {
  const nomeLimpo = nome.replace(/^(CPFL|ASAAS|PIX)\s+/i, '');
  const [imgReady, setImgReady] = React.useState(false);
  const [aspectRatio, setAspectRatio] = React.useState('600 / 380'); // fallback

  // Calibração: ligue isso pra true temporariamente pra ver um grid % sobre a carteirinha
  const CALIBRAR = false;

  React.useEffect(() => {
    if (!modeloUrl) return;
    setImgReady(false);
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = modeloUrl;
    img.onload = () => {
      // Usa a proporção REAL do arquivo, não mais um chute
      setAspectRatio(`${img.naturalWidth} / ${img.naturalHeight}`);
      setImgReady(true);
    };
    img.onerror = () => setImgReady(false);
  }, [modeloUrl]);

  const handleDownload = async () => {
    if (!imgReady) {
      alert('Aguarde o carregamento do modelo antes de baixar.');
      return;
    }
    const element = document.querySelector('.cart-card');
    if (!element) return;

    try {
      // Força fundo branco direto no DOM antes de capturar (é isso que estabiliza a cor)
      element.style.backgroundColor = '#ffffff';

      const canvas = await html2canvas(element, {
        scale: 4,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        letterRendering: true,
        allowTaint: true,
        removeContainer: true,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

      const pdfWidth = 297;
      const cardWidth = 200;
      const cardHeight = (canvas.height / canvas.width) * cardWidth;
      const x = (pdfWidth - cardWidth) / 2;
      const y = (210 - cardHeight) / 2;

      pdf.addImage(imgData, 'JPEG', x, y, cardWidth, cardHeight, '', 'FAST');
      pdf.save(`carteirinha_${nome.replace(/\s+/g, '_').toLowerCase()}.pdf`);

      element.style.backgroundColor = '';
    } catch (err) {
      console.error('Erro ao gerar PDF:', err);
      alert('Erro ao gerar PDF. Tente novamente.');
    }
  };

  return (
    <div>
      <div
        className="cart-card"
        style={{
          position: 'relative',
          overflow: 'visible',
          width: '100%',
          maxWidth: '600px',
          margin: '0 auto',
          aspectRatio, // agora é a proporção REAL da imagem carregada
          boxSizing: 'border-box',
          backgroundColor: '#ffffff'
        }}
      >
        {modeloUrl && (
          <img
            src={modeloUrl}
            crossOrigin="anonymous"
            alt="modelo carteirinha"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'fill', // agora que o aspectRatio bate exato, 'fill' não distorce
              userSelect: 'none',
              pointerEvents: 'none'
            }}
          />
        )}

        {/* Grid de calibração — mostra linhas a cada 5% pra você achar os offsets certos visualmente */}
        {CALIBRAR && Array.from({ length: 19 }).map((_, i) => (
          <React.Fragment key={i}>
            <div style={{
              position: 'absolute', top: `${(i + 1) * 5}%`, left: 0, right: 0,
              borderTop: '1px dashed rgba(255,0,0,0.4)', fontSize: '8px', color: 'red'
            }}>{(i + 1) * 5}%</div>
            <div style={{
              position: 'absolute', left: `${(i + 1) * 5}%`, top: 0, bottom: 0,
              borderLeft: '1px dashed rgba(0,0,255,0.4)'
            }} />
          </React.Fragment>
        ))}

        <div style={{
          position: 'absolute',
          top: '49%',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#000000',
          textAlign: 'center',
          width: '90%',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          lineHeight: '1.3',
          fontFamily: 'serif'
        }}>
          {nomeLimpo}
        </div>

        <div style={{
          position: 'absolute',
          top: '71%',
          left: '36.7%',
          fontSize: '13px',
          color: '#000000',
          fontWeight: '600'
        }}>
          {matricula || '—'}
        </div>

        <div style={{
          position: 'absolute',
          top: '78%',
          left: '52.3%',
          fontSize: '13px',
          color: '#000000',
          fontWeight: '600'
        }}>
          {nascimento || '—'}
        </div>
      </div>

      <button
        onClick={handleDownload}
        disabled={!imgReady}
        style={{
          marginTop: '16px',
          padding: '10px 20px',
          opacity: imgReady ? 1 : 0.5,
          cursor: imgReady ? 'pointer' : 'not-allowed'
        }}
      >
        {imgReady ? 'Baixar PDF' : 'Carregando modelo...'}
      </button>
    </div>
  );
}

function CarteirinhaModal({ client, onClose }) {
  const [modeloCarteirinha, setModeloCarteirinha] = useState(null);
  const [loadingModelo, setLoadingModelo] = useState(true);

const handleDownload = async () => {
  const element = document.querySelector('.cart-card');
  if (!element) return;

  try {
    // Força fundo branco antes de capturar
    element.style.backgroundColor = '#ffffff';
    
    // Captura a div da carteirinha com alta qualidade
    const canvas = await html2canvas(element, {
      scale: 4,
      useCORS: true,
      backgroundColor: '#ffffff', // Fundo branco sólido
      logging: false,
      letterRendering: true,
      allowTaint: true,
      removeContainer: true,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight
    });

    // Converte para JPEG com qualidade máxima (melhor para cores sólidas)
    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    
    // Cria o PDF em formato A4 paisagem
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    // Calcula as dimensões para centralizar a carteirinha no PDF
    const pdfWidth = 297;
    const pdfHeight = 210;
    
    // Tamanho da carteirinha no PDF
    const cardWidth = 200;
    const cardHeight = (canvas.height / canvas.width) * cardWidth;
    
    // Centraliza horizontal e verticalmente
    const x = (pdfWidth - cardWidth) / 2;
    const y = (pdfHeight - cardHeight) / 2;

    // Adiciona a imagem ao PDF
    pdf.addImage(imgData, 'JPEG', x, y, cardWidth, cardHeight, '', 'FAST');
    
    // Gera o nome do arquivo
    const nomeArquivo = `carteirinha_${nome.replace(/\s+/g, '_').toLowerCase()}.pdf`;
    
    // Baixa o PDF
    pdf.save(nomeArquivo);
    
    // Restaura o estilo original
    element.style.backgroundColor = '';
  } catch (err) {
    console.error('Erro ao gerar PDF:', err);
    alert('Erro ao gerar PDF. Tente novamente.');
  }
};

const dependentes = mockDependentes[client.id] || [];
  const [activeTab, setActiveTab] = useState('titular');
  const currentDep = dependentes.find(d => d.id === activeTab);
  
  // Dados do cliente
  const nome = client.full_name || client.name || '';
  const matricula = client.cpfl_installation_number || client.id || '';
  const nascimento = client.birth_date || client.dataNascimento || '—';
  const cidade = client.cityName || client.city || '—';

  // Buscar modelo de carteirinha do banco
  useEffect(() => {
    const fetchModelo = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('/api/admin/modelos/carteirinha', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setModeloCarteirinha(data);
        }
      } catch (err) {
        console.error('Erro ao buscar modelo de carteirinha:', err);
      } finally {
        setLoadingModelo(false);
      }
    };
    fetchModelo();
  }, []);

  return (
    <div className="carteirinha-overlay" onClick={onClose}>
      <div className="carteirinha-wrapper" onClick={e => e.stopPropagation()}>
        <div className="carteirinha-header-bar">
          <span> Carteirinhas — {nome.split(' ')[0]}</span>
          <button className="carteirinha-close" onClick={onClose}><X size={16} /></button>
        </div>
        <div className="cart-tabs">
          <button className={`cart-tab ${activeTab === 'titular' ? 'active' : ''}`} onClick={() => setActiveTab('titular')}>
            👤 Titular
          </button>
          {dependentes.length === 0 && <span className="cart-no-dep">Sem dependentes</span>}
        </div>
        <div className="cart-card-area">
          <CarteirinhaCard 
            nome={nome.toUpperCase()} 
            matricula={matricula} 
            nascimento={client.birth_date || '—'} 
            cidade={client.cityName || '—'} 
            isDep={false}
            modeloUrl={modeloCarteirinha?.url}
            loading={loadingModelo}
          />
        </div>
        <div className="carteirinha-actions">
                    <button className="carteirinha-btn-whatsapp"
            onClick={() => {
              const msg = encodeURIComponent(`🪪 *Carteirinha Saúde Soulidari*\n\n👤 *${nome}*\n📋 Matrícula: ${matricula}\n🏥 Saúde Soulidari\n📞 (11) 97636-0440`);
              window.open(`https://wa.me/?text=${msg}`, '_blank');
            }}
          >
            WhatsApp
          </button>
          <button className="carteirinha-btn-close" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

// ── UNIFICADA ─────────────────────────────────────────────────────────
function ClientTable({ clients, onView, onGerarCobranca, onCarteirinha, onPayments }) {
  return (
    <div className="client-table-wrapper">
      <table className="client-table">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>CPF / CNPJ</th>
            <th>Matrícula / ID</th>
            <th>Modalidade</th>
            <th>Cidade</th>
            <th>Plano</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((c, i) => {
            const isAsaas = c._source === 'asaas';
            const nome = c.full_name || c.name || '—';
            const cpf = c.cpf || '—';
            const matricula = c.cpfl_installation_number || c.id || '—';
            const cidade = c.cityName || '—';
            const plano = c.plan_name || '—';
            const status = c.status || (isAsaas ? (c.deleted ? 'inativo' : 'ativo') : 'ativo');
            return (
              <tr key={`${c._source}-${c.id}`} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                <td>
                  <div className="td-name-inner">
                    <div className={`mini-avatar ${isAsaas ? 'avatar-asaas' : ''}`}>{nome.charAt(0)}</div>
                    {nome}
                  </div>
                </td>
                <td className="td-cpf">{cpf}</td>
                <td className="td-mat">{matricula}</td>
                <td>
                  {isAsaas
                    ? <span className="type-badge type-asaas"><CreditCard size={14} /> Asaas</span>
                    : <span className="type-badge type-cpfl"><Zap size={14} /> CPFL</span>
                  }
                </td>
                <td className="td-cidade">{cidade}</td>
                <td className="td-plano">
                  <span className="plano-badge"><Star size={11} /> {plano}</span>
                </td>
                <td>
                  <span className={`status-badge status-${status.toLowerCase()}`}>{status}</span>
                </td>
                <td>
                  <div className="action-btns">
                    <button className="btn-action view" onClick={() => onView(c)} title="Ver detalhes">
                      <Eye size={16} />
                    </button>
                    <button className="btn-action cobranca" onClick={() => onGerarCobranca(c)} title="Gerar Cobrança">
                      <DollarSign size={16} />
                    </button>
                    {onPayments && (
                      <button className="btn-action payments" onClick={() => onPayments(c)} title="Ver Cobranças">
                        <FileText size={16} />
                      </button>
                    )}
                    <button className="btn-action carteirinha" onClick={() => onCarteirinha(c)} title="Ver carteirinha">
                      <CardIcon size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ─────────────────────────────────────────────────────
export default function Clients({ onNavigate, defaultView = 'menu', initialClient = null, openEdit = false }) {
  const [view, setView] = useState(defaultView);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [registerStep, setRegisterStep] = useState(1);
  const [cpflData, setCpflData] = useState(null);
  const [asaasData, setAsaasData] = useState(null);

  // Lista / busca
  const [activeTab, setActiveTab] = useState('todos');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searched, setSearched] = useState(false);

  // Cliente selecionado / edição / carteirinha
  const [selectedClient, setSelectedClient] = useState(null);
  const [editingClient, setEditingClient] = useState(null);
  const [carteirinhaClient, setCarteirinhaClient] = useState(null);
  const [paymentsModalClient, setPaymentsModalClient] = useState(null);

  const veioDeMeusClientes = Boolean(
    openEdit &&
    initialClient &&
    initialClient._source === 'cpfl'
  );

  useEffect(() => {
    if (openEdit && initialClient) {
      setEditingClient({ ...initialClient, _source: initialClient._source || 'cpfl' });
    }
  }, [openEdit, initialClient]);

  // CPFL
  const [cpflClients, setCpflClients] = useState([]);

  // ── Situação de pagamento dos clientes CPFL (rota GET /api/cpfl/adimplencia) ──
  const [adimp, setAdimp] = useState(null);            // dados carregados (continua null se a rota não responder)
  const [adimpLista, setAdimpLista] = useState(null);  // situação cuja lista está aberta
  const [adimpBusca, setAdimpBusca] = useState('');
  useEffect(() => {
    let vivo = true;
    const chave = (v) => String(v || '').replace(/\D/g, '').replace(/^0+/, '');
    fetch('/api/cpfl/adimplencia', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        if (!vivo || !j || !j.sucesso) return;
        const porUC = {};
        (j.clientes || []).forEach((c) => { porUC[chave(c.instalacao)] = c; });
        setAdimp({ porUC, porCpf: j.porCpf || {}, resumo: j.resumo || {}, referencia: j.referencia || {}, lista: j.clientes || [] });
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  const chaveUC = (v) => String(v || '').replace(/\D/g, '').replace(/^0+/, '');
  const ROTULO_PAG = {
    adimplente: 'Adimplente', adimplente_sem_conta: 'Adimplente (sem conta)', a_vencer: 'A vencer', inadimplente: 'Inadimplente',
    irregular: 'Irregular', estornada: 'Estornada', verificar: 'Verificar', novo: 'Novo', sem_info: 'Sem informação',
  };
  const DESC_PAG = {
    adimplente: 'Pagou no mês passado ou já pagou neste mês.',
    adimplente_sem_conta: 'Pagou há dois meses e a CPFL não emitiu conta nova depois (por exemplo, conta a cada dois meses). Segue adimplente até a próxima conta vencer sem pagamento.',
    a_vencer: 'A conta já saiu e o vencimento (mais a espera de alguns dias) ainda não passou.',
    inadimplente: 'A conta saiu depois do último pagamento e o vencimento (mais a espera de alguns dias) já passou sem pagamento.',
    irregular: 'A CPFL recusou ou sinalizou a cobrança (por exemplo, instalação cortada, inativa ou troca de titular). O motivo aparece em cada linha.',
    estornada: 'O valor foi retirado da conta de energia ou devolvido depois do pagamento.',
    verificar: 'Faltam dados para concluir (por exemplo, sem data de vencimento ou sem pagamento registrado). Vale conferir na CPFL.',
    novo: 'Cobrança cadastrada há até 60 dias, aguardando a primeira conta.',
    sem_info: 'Clientes CPFL sem nenhuma informação de pagamento vinda da CPFL (por exemplo, cobrança ainda não cadastrada ou instalação não encontrada).',
  };
  const ORDEM_PAG = ['adimplente', 'adimplente_sem_conta', 'a_vencer', 'inadimplente', 'irregular', 'estornada', 'verificar', 'novo'];
  const situacaoPagamento = (c) => {
    if (!adimp) return null;
    const porUC = adimp.porUC[chaveUC(c.cpfl_installation_number)] || adimp.porUC[chaveUC(c.instalacao_nova)];
    if (porUC) return porUC;
    const cpfDig = String(c.cpf || '').replace(/\D/g, '');
    return (cpfDig && adimp.porCpf[cpfDig]) || null;
  };
  const dataBRPag = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '');
  const nomeMesPag = (ym) => {
    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    return ym ? `${meses[Number(ym.slice(5, 7)) - 1]}/${ym.slice(0, 4)}` : '';
  };
  const baixarCsvPag = (itens, situacao) => {
    const seguro = (v) => { let s = String(v == null ? '' : v); if (/^[=+\-@]/.test(s)) s = `'${s}`; return `"${s.replace(/"/g, '""')}"`; };
    const linhas = [['Nome', 'CPF', 'Instalação', 'Situação', 'Último pagamento', 'Motivo']].concat(
      itens.map((c) => [c.nome, c.cpf, c.instalacao, ROTULO_PAG[c.situacao] || c.situacao, dataBRPag(c.ultimoPagamento), c.motivo]),
    );
    const csv = `\uFEFF${linhas.map((l) => l.map(seguro).join(';')).join('\r\n')}`;
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `clientes-cpfl-${situacao}-${(adimp && adimp.referencia.hoje) || 'hoje'}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  // ── Lista na própria tabela: clicar num botão do resumo (ou no filtro PAGAMENTO) mostra aqui os clientes dessa situação ──
  const [pagTodos, setPagTodos] = useState(null);       // todos os clientes CPFL carregados: { lista, em }
  const [pagCarregando, setPagCarregando] = useState(false);
  const [pagErro, setPagErro] = useState('');
  const [pagVisiveis, setPagVisiveis] = useState(100);  // quantas linhas aparecem (cresce de 100 em 100)
  const [colAberta, setColAberta] = useState(null);     // filtro de cabeçalho aberto: { chave, x, y }
  const [pagTrava] = useState({ ativo: false });
  const carregarTodosCpfl = async (forcar = false) => {
    if (pagTrava.ativo) return;
    if (!forcar && pagTodos && Date.now() - pagTodos.em < 5 * 60 * 1000) return;
    pagTrava.ativo = true;
    setPagCarregando(true);
    setPagErro('');
    try {
      const base = 'sort=-created_date&limit=5000&payment_type=cpfl';
      const r1 = await getClients(`${base}&page=1`);
      let lista = (r1.data || []).slice();
      const paginas = r1.totalPages || 1;
      for (let p = 2; p <= paginas; p += 1) {
        const r = await getClients(`${base}&page=${p}`);
        lista = lista.concat(r.data || []);
      }
      setPagTodos({ lista: lista.map((c) => ({ ...c, _source: 'cpfl' })), em: Date.now() });
    } catch (err) {
      console.error('Erro ao carregar todos os clientes CPFL:', err);
      setPagErro('Não foi possível carregar todos os clientes CPFL. Tente "Recarregar".');
    } finally {
      pagTrava.ativo = false;
      setPagCarregando(false);
    }
  };
  const escolherPagFiltro = (s, ligar = false) => {
    const desligar = !ligar && adimpLista === s && activeTab === 'cpfl';
    setAdimpBusca('');
    setPagVisiveis(100);
    setColAberta(null);
    if (desligar) { setAdimpLista(null); return; }
    setActiveTab('cpfl');
    setSearched(false);
    setSearchQuery('');
    setAdimpLista(s);
    carregarTodosCpfl();
  };
  const aoEscolherPag = (v) => { if (!v) setAdimpLista(null); else escolherPagFiltro(v, true); };
  useEffect(() => {
    const fechar = (e) => {
      if (e.target && e.target.closest && e.target.closest('.pag-filtro-pop, .pag-filtro-btn')) return;
      setColAberta(null);
    };
    document.addEventListener('click', fechar);
    window.addEventListener('scroll', fechar, true);
    return () => { document.removeEventListener('click', fechar); window.removeEventListener('scroll', fechar, true); };
  }, []);
  const [cpflLoading, setCpflLoading] = useState(false);
  const [cpflTotal, setCpflTotal] = useState(0);
  const [cpflPage, setCpflPage] = useState(1);
  const [cpflTotalPages, setCpflTotalPages] = useState(1);
  const [allCpflClients, setAllCpflClients] = useState([]);

  // Asaas
  const [asaasClients, setAsaasClients] = useState([]);
  const [asaasLoading, setAsaasLoading] = useState(false);
  const [asaasTotal, setAsaasTotal] = useState(0);
  const [celcoinClients, setCelcoinClients] = useState([]);
  const [celcoinLoading, setCelcoinLoading] = useState(false);
  const [celcoinTotal, setCelcoinTotal] = useState(0);
  const [celcoinCarregado, setCelcoinCarregado] = useState(false);
  const [pixTotal, setPixTotal] = useState(null);
  const [asaasOffset, setAsaasOffset] = useState(0);
  const [asaasHasMore, setAsaasHasMore] = useState(false);
  const ASAAS_LIMIT = 50;

  // Filtros
  const [filterCity, setFilterCity] = useState('');
  const [filterPlan, setFilterPlan] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterSituacao, setFilterSituacao] = useState('');
  const [distinctCities, setDistinctCities] = useState([]);
  const [distinctPlans, setDistinctPlans] = useState([]);
  const [distinctStatuses, setDistinctStatuses] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});
  const [recalcLoading, setRecalcLoading] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState('');
  const [endDateFilter, setEndDateFilter] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dashboardFilter = searchParams.get('dashboardFilter') || '';

  useEffect(() => {
    const statusPorFiltro = {
      ativos: 'ativo',
      inativos: 'inativo'
    };

    setFilterStatus(statusPorFiltro[dashboardFilter] || '');
    setActiveTab('cpfl');
  }, [dashboardFilter]);


  // ── AUTENTICAÇÃO E PERMISSÕES ──────────────────────────────────────────────
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];
  const userRoles = user?.roles || [];

  const isAtendente = userRoles.includes('Atendente') ||
    (userPermissions.length > 0 &&
      !userPermissions.includes('administracao') &&
      !userPermissions.includes('relatorios'));

  // Verifica se pode exportar dados (Admin, Gestor ou Financeiro)
  const canExportData = userRoles.some(role => 
  role.toLowerCase().includes('admin') || 
  role.toLowerCase().includes('gestor') || 
  role.toLowerCase().includes('financeiro')
);

  // ✅ Verifica se pode gerar cobrança (Admin, Gestor, Financeiro ou Atendente com permissão)
  const canGenerateCharge = userRoles.includes('Admin') ||
    userRoles.includes('Gestor') ||
    userRoles.includes('Financeiro') ||
    userPermissions.includes('gerar-cobranca');

  // ── Painel de Filtros (dropdown) ───────────────────────────────────────────
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [sortBy, setSortBy] = useState('data_criacao');
  const [situacaoCobranca, setSituacaoCobranca] = useState('todas');
  const [grupoFiltro, setGrupoFiltro] = useState('todos');
  const [identificadorExterno, setIdentificadorExterno] = useState('');

  const limparFiltrosPanel = () => {
    setSortBy('data_criacao');
    setSituacaoCobranca('todas');
    setGrupoFiltro('todos');
    setIdentificadorExterno('');
    setFilterStatus('');
    setFilterCity('');
  };

  const aplicarFiltrosPanel = () => {
    setFiltersOpen(false);
  };

  // ── Leitura de parâmetros da URL ───────────────────────────────────────────
  useEffect(() => {
    const tabParam = searchParams.get('tab');
    const situacaoParam = searchParams.get('situacao');
    const startDateParam = searchParams.get('startDate');
    const endDateParam = searchParams.get('endDate');

    if (tabParam === 'asaas') setActiveTab('asaas');
    else if (tabParam === 'cpfl') setActiveTab('cpfl');
    if (situacaoParam) setFilterSituacao(situacaoParam);
    if (startDateParam) setStartDateFilter(startDateParam);
    if (endDateParam) setEndDateFilter(endDateParam);
  }, [searchParams]);

  // ── Carregamentos iniciais ─────────────────────────────────────────────────
  useEffect(() => {
    getDistinctClients().then(r => {
      setDistinctCities(r.cities || []);
      setDistinctPlans(r.plans || []);
      setDistinctStatuses(r.statuses || []);
    }).catch(() => { });
  }, []);

  // Cache de todos os clientes CPFL para busca local (APENAS se NÃO for Atendente)
  useEffect(() => {
    if (isAtendente) return;
    const load = async () => {
      try {
        let all = [], page = 1, hasMore = true;
        while (hasMore) {
          const query = `sort=-created_date&limit=200&page=${page}&payment_type=cpfl`;
          const r = await getClients(query);
          all = [...all, ...(r.data || []).map(c => ({ ...c, _source: 'cpfl' }))];
          hasMore = r.data?.length === 200;
          page++;
          if (page > 10) break;
        }
        setAllCpflClients(all);
      } catch { }
    };
    load();
  }, [isAtendente]);

  // ── Carregar clientes CPFL paginado ────────────────────────────────────────
  const loadCpflClients = async (page = 1) => {
    setCpflLoading(true);
    try {
      const params = new URLSearchParams({
        sort: '-created_date',
        limit: '50',
        page: String(page),
        payment_type: 'cpfl'
      });
      if (filterCity) params.append('cityName', filterCity);
      if (filterPlan) params.append('plan_name', filterPlan);
      if (filterStatus) params.append('status', filterStatus);
      if (filterSituacao) params.append('situacao', filterSituacao);
      if (dashboardFilter) params.append('dashboardFilter', dashboardFilter);

      const queryString = params.toString();
      const r = await getClients(queryString);
      setCpflClients((r.data || []).map(c => ({ ...c, _source: 'cpfl' })));
      setCpflTotal(r.total || 0);
      setCpflPage(r.page || 1);
      setCpflTotalPages(r.totalPages || 1);
      setStatusCounts(r.statusCounts || {});
    } catch (error) {
      console.error('Erro ao carregar clientes CPFL:', error);
    } finally {
      setCpflLoading(false);
    }
  };

    // ── Carregar clientes Asaas ────────────────────────────────────────────────
  // Filtro de exibição: alguns clientes foram cadastrados diretamente no Asaas
  // pela operadora com o nome prefixado "CPFL " — não usamos esses, só escondemos
  // da tela (o dado continua existindo no Asaas normalmente, nada é apagado nem
  // alterado lá).
  const isClienteCpflFalso = (nome) => (nome || '').trim().toUpperCase().startsWith('CPFL ');

  const loadAsaasClients = async (offset = 0) => {
    setAsaasLoading(true);
    try {
      const r = await getAsaasClients({ limit: ASAAS_LIMIT, offset });
      const listaBruta = (r.data || []).map(c => ({
        ...c,
        _source: 'asaas',
        cpf: c.cpfCnpj
      }));
      const lista = listaBruta.filter(c => !isClienteCpflFalso(c.name || c.full_name));
      const removidos = listaBruta.length - lista.length;
      setAsaasClients(lista);
      setAsaasTotal(Math.max(0, (r.totalCount || listaBruta.length) - removidos));
      setAsaasOffset(offset);
      setAsaasHasMore(r.hasMore || false);
    } catch { } finally { setAsaasLoading(false); }
  };
  // ── Carregar clientes Celcoin ───────────────────────────────────────────────
  const loadCelcoinClients = async (startAt = 0) => {
    setCelcoinLoading(true);
    try {
      const r = await getCelcoinClients({ limit: 50, startAt });
      const customers = r.dados?.Customers || [];
      const lista = customers.map((c) => ({
        id: c.galaxPayId,
        // full_name/cpf: usados pela TABELA. name/cpfCnpj: usados pelo
        // FORMULÁRIO de edição (mesmo formato do Asaas) — precisa dos dois.
        full_name: c.name,
        name: c.name,
        cpf: c.document,
        cpfCnpj: c.document,
        email: c.emails?.[0] || '',
        phone: c.phones?.[0] ? String(c.phones[0]) : '',
        mobilePhone: c.phones?.[1] ? String(c.phones[1]) : '',
        cityName: c.Address?.city || '',
        state: c.Address?.state || '',
        address: c.Address?.street || '',
        addressNumber: c.Address?.number || '',
        complement: c.Address?.complement || '',
        province: c.Address?.neighborhood || '',
        postalCode: c.Address?.zipCode || '',
        status: c.status,
        _source: 'celcoin',
      }));
      setCelcoinClients(lista);
      setCelcoinTotal(r.dados?.totalQtdFoundInPage || lista.length);
    } catch (err) {
      console.error('Erro ao carregar clientes Celcoin:', err);
    } finally {
      setCelcoinLoading(false);
      setCelcoinCarregado(true);
    }
  };

  // Recarrega quando filtros mudam (APENAS se NÃO for Atendente)
  useEffect(() => {
    if (isAtendente) return;
    setSearched(false);
    setSearchQuery('');
    loadCpflClients(1);
    loadAsaasClients(0);
  }, [filterCity, filterPlan, filterStatus, filterSituacao, dashboardFilter]);
  // Carrega a contagem de clientes Pix na abertura da página (só para quem usa a modalidade Pix).
  useEffect(() => {
    if (!modalidadesPorUsuario(user).includes('pix')) return;
    getClients('payment_type=pix&limit=1').then((r) => setPixTotal(r.total || 0)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Carrega a contagem de clientes Celcoin já na abertura da página (só uma vez).
  useEffect(() => {
    if (isAtendente) return;
    loadCelcoinClients(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function ImportadorCPFL() {
    const [loading, setLoading] = useState(false);

    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      const token = localStorage.getItem('token');
      if (!token) {
        alert('Sessão expirada. Faça login novamente.');
        return;
      }

      setLoading(true);
      try {
        const response = await axios.post('/api/clients/import-cpfl', formData, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        console.log('📊 Resultado importação:', response.data);

        let mensagem = response.data.message;
        if (response.data.erros && response.data.erros.length > 0) {
          console.table(response.data.erros);
          mensagem += `\n\nFalhas (${response.data.falhas}):\n` +
            response.data.erros.map(e => `Linha ${e.linha}: ${e.motivo}`).join('\n');
        }

        alert(mensagem);

        if (response.data.sucessos > 0) {
          await loadCpflClients(1);
          await loadAsaasClients(0);
          setActiveTab('cpfl');
          setSearched(false);
          setSearchQuery('');
        }
      } catch (error) {
        console.error('Erro na importação:', error);
        const msg = error.response?.data?.error || error.message;
        alert('Erro na importação: ' + msg);
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="import-section" style={{ margin: '20px 0', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <label className="btn-import" style={{
          backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px',
          borderRadius: '8px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px',
          fontWeight: 500
        }}>
          <CloudUpload size={18} />
          {loading ? 'Processando Planilha...' : 'Importar Planilha CPFL'}
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} style={{ display: 'none' }} disabled={loading} />
        </label>
        <span style={{ fontSize: '13px', color: '#666' }}>
          Colunas: <strong>CPF</strong>, <strong>INSTALAÇÃO</strong>, <strong>PN</strong>
        </span>
      </div>
    );
  }

  // ── Exportar para Excel ────────────────────────────────────────────────────
   const exportToExcel = async () => {
    console.log('🚀 Iniciando exportação...');
    let dataToExport = [];

    try {
      // 1. Coletar os dados conforme a aba ativa
      if (activeTab === 'cpfl') {
        dataToExport = allCpflClients;
      } else if (activeTab === 'asaas') {
        const r = await getAsaasClients({ limit: 9999, offset: 0 });
        dataToExport = (r.data || []).map(c => ({ ...c, _source: 'asaas' }));
      } else {
        dataToExport = [...allCpflClients];
        const r = await getAsaasClients({ limit: 9999, offset: 0 });
        dataToExport = [...dataToExport, ...(r.data || []).map(c => ({ ...c, _source: 'asaas' }))];
      }

      console.log('📦 Dados coletados para exportação:', dataToExport.length, 'clientes');

      if (!dataToExport || dataToExport.length === 0) {
        alert('Nenhum dado encontrado para exportar nesta aba.');
        return;
      }

      // 2. Formatar os dados para a planilha
      const sheetData = dataToExport.map(client => {
        const isAsaas = client._source === 'asaas';
        return {
          'Nome': client.full_name || client.name || '',
          'CPF/CNPJ': isAsaas ? (client.cpfCnpj || '') : (client.cpf || ''),
          'PN': !isAsaas ? (client.cpfl_account_number || '') : '',
          'Instalação': !isAsaas ? (client.cpfl_installation_number || '') : '',
          'Matrícula/ID': isAsaas ? (client.id || '') : (client.cpfl_installation_number || ''),
          'Modalidade': isAsaas ? 'Asaas' : 'CPFL',
          'Cidade': client.cityName || '',
          'Plano': client.plan_name || '',
          'Status': client.status || (isAsaas ? (client.deleted ? 'Inativo' : 'Ativo') : 'Ativo'),
          'Telefone': client.phone || client.mobilePhone || '',
          'Email': client.email || '',
          'Endereço': client.address || '',
          'CEP': client.zip_code || client.postalCode || '',
          'Data Cadastro': client.created_date ? new Date(client.created_date).toLocaleDateString('pt-BR') : '',
        };
      });

      console.log('📄 Gerando planilha com', sheetData.length, 'linhas...');

      // 3. Gerar e baixar o arquivo Excel
      const ws = XLSX.utils.json_to_sheet(sheetData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Clientes');
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      
      console.log('💾 Salvando arquivo: clientes_' + timestamp + '.xlsx');
      XLSX.writeFile(wb, `clientes_${timestamp}.xlsx`);
      console.log('✅ Exportação concluída com sucesso!');
      
    } catch (err) {
      console.error('❌ Erro ao exportar para Excel:', err);
      alert('Ocorreu um erro ao exportar os dados. Verifique o console (F12) para mais detalhes.');
    }
  };

 

  // ── Busca local ou via API (para Atendente) ────────────────────────────────
    


// ── Busca via API (para TODOS os cargos, garantindo busca real) ───────────
  const performSearch = async (term) => {
  if (!term.trim()) {
    setSearchResults([]);
    setSearched(true);
    return;
  }

  setCpflLoading(true);
  try {
    const t = term.toLowerCase().trim().replace(/\s+/g, ' ');
    const hasDigits = /\d/.test(t);

    // 1. Buscar no Backend SOMENTE clientes CPFL
    const paramsCpfl = new URLSearchParams({
      sort: '-created_date',
      limit: '100',
      page: '1',
      payment_type: 'cpfl'   // ← ADICIONE ESTA LINHA
    });

    if (hasDigits) {
      paramsCpfl.append('cpf', t.replace(/\D/g, ''));
    } else {
      paramsCpfl.append('search', t);
    }

    const rCpfl = await getClients(paramsCpfl.toString());
    let cpflResults = (rCpfl.data || []).map(c => ({ ...c, _source: 'cpfl' }));

    // 2. Buscar na API da Asaas (já está correto)
    const paramsAsaas = { limit: 100, offset: 0 };
    if (hasDigits) {
      paramsAsaas.cpfCnpj = t.replace(/\D/g, '');
    } else {
      paramsAsaas.name = t;
    }

    const rAsaas = await getAsaasClients(paramsAsaas);
    let asaasResults = (rAsaas.data || []).map(c => ({
      ...c,
      _source: 'asaas',
      cpf: c.cpfCnpj
    }));

    // 3. A busca vale para TODAS as fontes (CPFL e Asaas; na aba Todos o bloco Pix aparece abaixo), de qualquer aba.
    //    So as abas Celcoin e Pix, que tem busca propria, continuam como eram.
    const abaComBuscaPropria = activeTab === 'celcoin' || activeTab === 'pix';
    let results = [];
    if (abaComBuscaPropria) results = asaasResults;
    else results = [...cpflResults, ...asaasResults];

    setSearchResults(results);
    setSearched(true);
    if (!abaComBuscaPropria) setActiveTab('todos'); // marca "Todos": e a aba que representa o que foi mostrado
  } catch (err) {
    console.error('Erro na busca:', err);
    setSearchResults([]);
    setSearched(true);
  } finally {
    setCpflLoading(false);
  }
};
   const handleSearch = () => performSearch(searchQuery.trim());

  // ── Clientes exibidos na tabela ────────────────────────────────────────────
  // ── Lista na tabela (situação de pagamento) e filtros de cabeçalho ──
  const pagAtivo = !!adimpLista && activeTab === 'cpfl' && !searched;
  const linhasPag = (() => {
    if (!pagAtivo || !pagTodos) return [];
    const q = adimpBusca.trim().toLowerCase();
    const dig = q.replace(/\D/g, '');
    return pagTodos.lista.filter((c) => {
      const pag = situacaoPagamento(c);
      if ((pag ? pag.situacao : 'sem_info') !== adimpLista) return false;
      if (filterCity && String(c.cityName || c.city || '').toLowerCase() !== filterCity.toLowerCase()) return false;
      if (filterStatus && String(c.status || 'ativo').toLowerCase() !== filterStatus.toLowerCase()) return false;
      if (filterPlan && String(c.plan_name || '') !== filterPlan) return false;
      if (!q) return true;
      // só números: procura no CPF e na instalação; com letras: procura só no nome
      if (/^[\d.\-/\s]+$/.test(q)) {
        return !!dig && (String(c.cpf || '').replace(/\D/g, '').includes(dig) || String(c.cpfl_installation_number || '').includes(dig));
      }
      return String(c.full_name || c.name || '').toLowerCase().includes(q);
    });
  })();
  const linhasPagVisiveis = linhasPag.slice(0, pagVisiveis);
  const itensCsvPag = linhasPag.map((c) => {
    const pag = situacaoPagamento(c) || {};
    return {
      nome: c.full_name || c.name || '', cpf: String(c.cpf || ''), instalacao: String(c.cpfl_installation_number || ''),
      situacao: pag.situacao || 'sem_info', ultimoPagamento: pag.ultimoPagamento || null, motivo: pag.motivo || 'Sem informação de pagamento da CPFL',
    };
  });
  const esperadoPag = adimp && adimp.resumo ? adimp.resumo[adimpLista] : null;
  const notaPag = pagAtivo && esperadoPag != null && !adimpBusca.trim() && !filterCity && !filterStatus && !filterPlan && linhasPag.length !== esperadoPag
    ? ` (o resumo conta ${esperadoPag} instalações; aqui aparecem os clientes cadastrados que casam com elas)` : '';
  const textoOpcaoPag = (x) => (typeof x === 'string' ? x : (x && (x.name || x.cityName || x.city || x.status || x.value || x.label)) || '');
  const unicasPag = (arr) => [...new Set((arr || []).map(textoOpcaoPag).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'pt-BR'));
  const opcCidadePag = unicasPag(distinctCities).map((v) => ({ valor: v, rotulo: v }));
  const opcStatusPag = (unicasPag(distinctStatuses).length ? unicasPag(distinctStatuses) : ['ativo', 'inativo']).map((v) => ({ valor: v, rotulo: v }));
  const opcPagamentoPag = ORDEM_PAG.map((v) => ({ valor: v, rotulo: ROTULO_PAG[v] })).concat([{ valor: 'sem_info', rotulo: ROTULO_PAG.sem_info }]);
  const renderFiltroCol = (chave, titulo, valor) => (
    <span className="pag-filtro-caixa">
      <button
        type="button"
        className={`pag-filtro-btn${valor ? ' ativo' : ''}`}
        title={`Filtrar ${titulo}`}
        aria-label={`Filtrar ${titulo}`}
        onClick={(e) => {
          e.stopPropagation();
          const r = e.currentTarget.getBoundingClientRect();
          setColAberta(colAberta && colAberta.chave === chave ? null : { chave, x: Math.max(8, Math.min(r.left, window.innerWidth - 232)), y: r.bottom + 4 });
        }}
      >
        <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
      </button>
    </span>
  );
  const renderPopupCol = () => {
    if (!colAberta) return null;
    const cfg = {
      cidade: [opcCidadePag, filterCity, setFilterCity],
      status: [opcStatusPag, filterStatus, setFilterStatus],
      pagamento: [opcPagamentoPag, pagAtivo ? adimpLista : '', aoEscolherPag],
    }[colAberta.chave];
    if (!cfg) return null;
    const [opcoes, valor, escolher] = cfg;
    return (
      <div className="pag-filtro-pop" style={{ left: colAberta.x, top: colAberta.y }} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={!valor ? 'sel' : ''} onClick={() => { escolher(''); setColAberta(null); }}>Todos</button>
        {opcoes.length === 0 && <div className="pag-filtro-vazio">Sem opções</div>}
        {opcoes.map((o) => (
          <button key={o.valor} type="button" className={String(valor).toLowerCase() === String(o.valor).toLowerCase() ? 'sel' : ''} onClick={() => { escolher(o.valor); setColAberta(null); }}>{o.rotulo}</button>
        ))}
      </div>
    );
  };

  const displayedClients = () => {
    if (isAtendente && !searched) {
      return [];
    }

    let base = [];
    if (activeTab === 'cpfl') base = cpflClients;
    else if (activeTab === 'asaas') base = asaasClients;
    else if (activeTab === 'celcoin') base = celcoinClients;
    else base = [...cpflClients, ...asaasClients];

    if ((activeTab === 'celcoin' || activeTab === 'asaas') && filterStatus) {
      // Celcoin e Asaas usam valores próprios de status (ex: "inactive",
      // "withoutSubscriptionOrCharge" na Celcoin; "deleted" no Asaas) — mapeia
      // pro nosso filtro ativo/inativo em vez de comparar direto com "ativo".
      const statusLower = filterStatus.toLowerCase();
      const isInativoFiltro = statusLower.includes('inativ') || statusLower === 'inactive' || statusLower === 'deleted';
      if (activeTab === 'celcoin') {
        base = isInativoFiltro
          ? base.filter(c => (c.status || '').toLowerCase() === 'inactive')
          : base.filter(c => (c.status || '').toLowerCase() !== 'inactive');
      } else if (activeTab === 'asaas') {
        base = isInativoFiltro
          ? base.filter(c => c.deleted === true)
          : base.filter(c => c.deleted !== true);
      }
    }

    if (filterSituacao) {
      base = base.filter(c => c.situacao === filterSituacao);
    }

    if (activeTab === 'asaas' && startDateFilter && endDateFilter && filterSituacao === 'INADIMPLENTE') {
      base = base.filter(c => {
        const lastDate = c.last_invoice_date;
        const lastStatus = c.last_invoice_status;
        return lastDate && lastDate >= startDateFilter && lastDate <= endDateFilter && lastStatus === 'OVERDUE';
      });
    }

    return base;
  };

  const celcoinTotalFiltrado = () => {
    if (!filterStatus) return celcoinTotal;
    const statusLower = filterStatus.toLowerCase();
    const isInativoFiltro = statusLower.includes('inativ') || statusLower === 'inactive';
    return isInativoFiltro
      ? celcoinClients.filter(c => (c.status || '').toLowerCase() === 'inactive').length
      : celcoinClients.filter(c => (c.status || '').toLowerCase() !== 'inactive').length;
  };
  const isLoading = cpflLoading || asaasLoading;
  const totalDisplayed = activeTab === 'cpfl' ? cpflTotal : activeTab === 'asaas' ? asaasTotal : cpflTotal + asaasTotal;

  // ── Recálculo ──────────────────────────────────────────────────────────────
  const handleRecalcStatus = async () => {
    setRecalcLoading(true);
    try {
      const result = await recalcClientStatus();
      if (result.success) { await loadCpflClients(cpflPage); alert('Status atualizados!'); }
      else alert('Erro ao recalcular status.');
    } catch { alert('Erro ao recalcular status.'); }
    finally { setRecalcLoading(false); }
  };

// ✅ CORRIGIDO: Gerar cobrança usando navigate() com state
const handleGerarCobranca = (client) => {
  // Verifica permissão
  if (!canGenerateCharge) {
    alert('Você não tem permissão para gerar cobranças.');
    return;
  }

  const clientToSend = {
    ...client,
    cpf: client.cpf || client.cpfCnpj
  };

  console.log('💰 [Clients] Gerando cobrança para:', clientToSend.name || clientToSend.full_name);
  console.log('💰 [Clients] Navegando para /gerar-cobranca');

  // ✅ Salva no localStorage (backup)
  localStorage.setItem('clienteGerarCobranca', JSON.stringify(clientToSend));
  
  // ✅ Salva no sessionStorage (mais seguro)
  sessionStorage.setItem('gc_cliente', JSON.stringify(clientToSend));

  // ✅ Navega usando navigate() com state (padrão react-router)
  navigate('/gerar-cobranca', { 
    state: { client: clientToSend }
  });
};

  // ✅ CORREÇÃO: Ver cobranças abre o modal
  const handleViewPayments = (client) => {
    console.log('📋 Abrindo modal de cobranças para:', client.name || client.full_name);
    setPaymentsModalClient(client);
  };

  const resetRegister = () => {
    setView('search');
    setRegisterStep(1);
    setPaymentMethod(null);
    setCpflData(null);
    setAsaasData(null);
    loadCpflClients(1);
    loadAsaasClients(0);
  };

  const abrirCadastro = () => {
    setView('register');
    setRegisterStep(1);
    setPaymentMethod(null);
    navigate('/meus-clientes/cadastro');
  };

  // ── Salvar edição de cliente ───────────────────────────────────────────────
  const handleEditSave = async (updatedData) => {
    try {
      if (editingClient._source === 'cpfl') {
        const token = localStorage.getItem('token');
        await axios.put(`/api/clients/${editingClient.id}`, updatedData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        await loadCpflClients(cpflPage);
      } else if (editingClient._source === 'asaas') {
        const payload = {
          name: updatedData.name,
          email: updatedData.email,
          cpfCnpj: updatedData.cpfCnpj,
          phone: updatedData.phone,
          mobilePhone: updatedData.mobilePhone,
          address: updatedData.address,
          addressNumber: updatedData.addressNumber,
          complement: updatedData.complement,
          province: updatedData.province,
          postalCode: updatedData.postalCode,
          city: updatedData.cityName || '',
          state: updatedData.state,
          plan_name: updatedData.plan_name,
          vendedor: updatedData.vendedor
        };
        await updateAsaasClient(editingClient.id, payload);
        await loadAsaasClients(asaasOffset);
      }
      setEditingClient(null);
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

    // ── Renderizações de tela especial ─────────────────────────────────────────
  if (editingClient) return (
    <div className="clients-container">
      <ClientEdit
        client={editingClient}
        onBack={() => {
          setEditingClient(null);

          if (veioDeMeusClientes) {
            navigate('/meus-clientes', { replace: true });
          }
        }}
        onSave={handleEditSave}
      />
    </div>
  );
  if (selectedClient) return (
    <div className="clients-container">
      <ClientDetail
        client={selectedClient}
        onBack={() => setSelectedClient(null)}
        onEdit={c => { setSelectedClient(null); setEditingClient(c); }}
        onGerarCobranca={handleGerarCobranca}
      />
    </div>
  );
  if (carteirinhaClient) return <CarteirinhaModal client={carteirinhaClient} onClose={() => setCarteirinhaClient(null)} />;

  // Passo 2 CPFL
  if (view === 'register' && registerStep === 2 && paymentMethod === 'cpfl') {
    return (
      <div className="clients-container">
        <CpflStep2
          onBack={() => setRegisterStep(1)}
          onNext={(data, docs) => { setCpflData({ ...data, docs }); setRegisterStep(3); }}
        />
      </div>
    );
  }

  // Passo 3 CPFL
  if (view === 'register' && registerStep === 3 && paymentMethod === 'cpfl') {
    return (
      <div className="clients-container">
        <CpflStep3
          key={cpflData?.uc + (cpflData?.titularDoPlano ? 'titular' : 'naoTitular')}
          cpflData={cpflData}
          onBack={() => setRegisterStep(2)}
          onSave={() => resetRegister()}
          onSaveAndCharge={() => {
            resetRegister();
          }}
        />
      </div>
    );
  }

  // Passo 2 Pix Santander
  if (view === 'register' && registerStep === 2 && paymentMethod === 'pix') {
    return (
      <div className="clients-container">
        <PixStep2
          onBack={() => setRegisterStep(1)}
          onSaved={() => resetRegister()}
          onSaveAndCharge={(clienteSalvo) => {
            resetRegister();
            handleGerarCobranca(clienteSalvo);
          }}
        />
      </div>
    );
  }

  // Passo 2 Asaas
  if (view === 'register' && registerStep === 2 && paymentMethod === 'asaas') {
    return (
      <div className="clients-container">
        <AsaasStep2
          onBack={() => setRegisterStep(1)}
          onNext={(data) => { setAsaasData(data); setRegisterStep(3); }}
        />
      </div>
    );
  }

  if (view === 'register' && paymentMethod === 'asaas') {
    return (
      <div className="clients-container">
        <AsaasStep2
          onBack={() => {
            setPaymentMethod(null);
            setRegisterStep(1);
            setView('register');
          }}
          onNavigate={onNavigate}
          onSaveAndCharge={(cliente) => {
            resetRegister();
            handleGerarCobranca(cliente);
          }}
        />
      </div>
    );
  }

  // ── Render Menu ────────────────────────────────────────────────────────────
  const renderMenu = () => (
    <div className="clients-menu">
      <h1>Meus Clientes</h1>
      <div className="options-grid">
        <button className="option-card search" onClick={() => setView('search')}>
          <div className="icon-circle"><Search size={30} /></div>
          <h2>Consulta de Clientes</h2>
          <p>Buscar e visualizar dados de clientes existentes</p>
        </button>
        <button className="option-card register" onClick={() => { setView('register'); setRegisterStep(1); setPaymentMethod(null); }}>
          <div className="icon-circle"><Plus size={30} /></div>
          <h2>Cadastro de Clientes</h2>
          <p>Registrar novo cliente no sistema</p>
        </button>
      </div>
    </div>
  );

  // ── Render Search ──────────────────────────────────────────────────────────
  const renderSearch = () => (
    <div className="clients-view-modern">
      {/* Título da página */}
      <div className="page-header-title">
        <h1>Consulta de Clientes</h1>
        <p className="page-subtitle">Buscar e visualizar dados de clientes existentes</p>
      </div>
      {/* Header simplificado */}
      <div className="modern-header">
        <div className="modern-header-top">
          <div className="search-wrapper-modern">
            <input
              type="text"
              placeholder="Procurar por nome, email, CPF ou CNPJ"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              className="search-input-modern"
            />
            <button className="search-btn-modern" onClick={handleSearch} title="Buscar">
              <Search size={16} />
            </button>
          </div>

          <div className="modern-header-actions">

            <button
              className="btn-export-modern"
              onClick={exportToExcel}
              disabled={!canExportData}
              title={!canExportData ? "Você não tem permissão para exportar dados" : "Exportar dados para Excel"}
              style={!canExportData ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            >
              <Download size={16} />
              Exportar Dados
            </button>
            <button className="btn-add-client-modern" onClick={abrirCadastro}>
              <Plus size={16} />
              Adicionar cliente
            </button>
          </div>
        </div>

        {/* Tabs de fonte */}
        <div className="modalidade-tabs-modern">
          <button
            className={`modalidade-tab-modern ${(activeTab === 'todos' || (isAtendente && activeTab !== 'pix')) ? 'active' : ''}`}
            data-busca-global="sim"
            onClick={() => { setActiveTab('todos'); setSearched(false); setSearchQuery(''); }}
          >
            Todos ({cpflTotal + asaasTotal})
          </button>
          {/* MD3: o atendente vê só "Todos"; CPFL, Asaas e Celcoin ficam para admin e gestor */}
          {!isAtendente && (
            <>
          <button
            className={`modalidade-tab-modern cpfl ${activeTab === 'cpfl' ? 'active' : ''}`}
            onClick={() => { setActiveTab('cpfl'); setSearched(false); setSearchQuery(''); }}
          >
            <Zap size={14} />
            CPFL ({cpflTotal})
          </button>
          <button
            className={`modalidade-tab-modern asaas ${activeTab === 'asaas' ? 'active' : ''}`}
            onClick={() => { setActiveTab('asaas'); setSearched(false); setSearchQuery(''); }}
          >
            <CreditCard size={14} />
            Asaas ({asaasTotal})
          </button>
          <button
            className={`modalidade-tab-modern celcoin ${activeTab === 'celcoin' ? 'active' : ''}`}
            style={activeTab === 'celcoin' ? { borderColor: '#16a34a', color: '#16a34a', background: '#f0fdf4' } : {}}
            onClick={() => {
              setActiveTab('celcoin'); setSearched(false); setSearchQuery('');
              if (!celcoinCarregado) loadCelcoinClients(0);
            }}
          >
            <CreditCard size={14} />
            Celcoin{celcoinCarregado ? ` (${celcoinTotalFiltrado()})` : ''}
          </button>
            </>
          )}
          {modalidadesPorUsuario(user).includes('pix') && (
            <button
              className={`modalidade-tab-modern pix ${activeTab === 'pix' ? 'active' : ''}`}
              style={activeTab === 'pix' ? { borderColor: '#0e7490', color: '#0e7490', background: '#ecfeff' } : {}}
              onClick={() => { setActiveTab('pix'); setSearched(false); setSearchQuery(''); }}
            >
              <Smartphone size={14} />
              Pix{pixTotal !== null ? ` (${pixTotal})` : ''}
            </button>
          )}
        </div>
        {activeTab === 'celcoin' && celcoinLoading && (
          <div style={{ marginTop: 16, padding: '20px', textAlign: 'center', color: '#6b7280', fontSize: 13 }}>
            Buscando clientes na Celcoin...
          </div>
        )}
      </div>

      {activeTab === 'pix' && (
        <PixClientsTab
          getClients={getClients}
          query={searchQuery}
          isAtendente={isAtendente}
          filterStatus={filterStatus}
          filterCity={filterCity}
          canCharge={canGenerateCharge}
          roles={userRoles}
          onGenerateCharge={handleGerarCobranca}
          onTotal={setPixTotal}
        />
      )}

      {/* Mensagem inicial para Atendente */}
      {activeTab !== 'pix' && isAtendente && !searched && (
        <div className="atendente-empty-state">
          <div className="atendente-empty-icon">
            <Search size={48} />
          </div>
          <h3>Realize uma busca para visualizar os clientes</h3>
          <p>Digite o nome, CPF, CNPJ ou matrícula do cliente no campo de busca acima e pressione Enter ou clique no ícone de lupa.</p>
        </div>
      )}

      {/* Resumo da situação de pagamento dos clientes CPFL (não aparece para Atendente) */}
      {!isAtendente && adimp && activeTab !== 'pix' && activeTab !== 'asaas' && activeTab !== 'celcoin' && (
        <div className="pag-resumo">
          <span className="pag-resumo-titulo" title="Pagou no mês passado ou neste mês = adimplente">
            Pagamento dos clientes CPFL · {nomeMesPag(adimp.referencia.mesPassado)} e {nomeMesPag(adimp.referencia.mesAtual)}
          </span>
          {ORDEM_PAG.filter((s) => adimp.resumo[s] > 0).map((s) => (
            <button key={s} type="button" className={`pag-chip pag-${s}${adimpLista === s && pagAtivo ? ' pag-chip-ativo' : ''}`} onClick={() => escolherPagFiltro(s)}>
              {ROTULO_PAG[s]} <b>{adimp.resumo[s]}</b>
            </button>
          ))}
        </div>
      )}
      {renderPopupCol()}
      {!isAtendente && pagAtivo && (
        <div className="pag-faixa">
          <span className="pag-faixa-info">
            {pagErro || ((pagCarregando || !pagTodos)
              ? 'Carregando todos os clientes CPFL…'
              : (<>Mostrando <b>{linhasPag.length}</b> cliente(s) · <b>{ROTULO_PAG[adimpLista]}</b>{notaPag}</>))}
          </span>
          <input type="text" className="pag-faixa-busca" placeholder="Buscar nesta lista" value={adimpBusca} onChange={(e) => { setAdimpBusca(e.target.value); setPagVisiveis(100); }} />
          <button type="button" className="pag-faixa-btn" disabled={!pagTodos || linhasPag.length === 0} onClick={() => baixarCsvPag(itensCsvPag, adimpLista)}>Baixar CSV</button>
          <button type="button" className="pag-faixa-btn" disabled={pagCarregando} onClick={() => carregarTodosCpfl(true)}>Recarregar</button>
          <button type="button" className="pag-faixa-btn pag-faixa-limpar" onClick={() => setAdimpLista(null)}>Limpar filtro</button>
          <div className="pag-faixa-desc">{DESC_PAG[adimpLista] || ''}</div>
        </div>
      )}

      {/* Tabela de clientes */}
      {activeTab !== 'pix' && (!isAtendente || searched) && (
        <div className="client-table-modern-wrapper">
          <table className="client-table-modern">
            <thead>
              <tr>
                <th>CLIENTE</th>
                <th>CPF / CNPJ</th>
                {!isAtendente && <th>MATRÍCULA / ID</th>}
                <th>MODALIDADE</th>
                <th>CIDADE{!isAtendente && renderFiltroCol('cidade', 'cidade', filterCity)}</th>
                <th>PLANO</th>
                <th>STATUS{!isAtendente && renderFiltroCol('status', 'status', filterStatus)}</th>
                <th>PAGAMENTO{!isAtendente && renderFiltroCol('pagamento', 'pagamento', pagAtivo ? adimpLista : '')}</th>
                <th>AÇÕES</th>
              </tr>
            </thead>
            <tbody>
              {(searched ? searchResults : (pagAtivo ? linhasPagVisiveis : displayedClients())).map((c, i) => {
                const isAsaas = c._source === 'asaas';
                const isCelcoin = c._source === 'celcoin';
                const nome = c.full_name || c.name || '—';
                const cpf = c.cpf || '—';
                const matricula = c.cpfl_installation_number || c.id || '—';
                const cidade = c.cityName || c.city || '—';
                const plano = c.plan_name || '—';
                const status = c.status || (isAsaas ? (c.deleted ? 'inativo' : 'ativo') : 'ativo');

                return (
                  <tr key={`${c._source}-${c.id}`} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                    <td>
                      <div className="td-name-inner-modern">
                        <div className={`mini-avatar-modern ${isAsaas ? 'avatar-asaas' : isCelcoin ? '' : 'avatar-cpfl'}`} style={isCelcoin ? { background: '#16a34a' } : {}}>
                          {nome.charAt(0)}
                        </div>
                        <div className="client-info-cell">
                          <div className="client-name-cell">{nome}</div>
                          {c.email && (
                            <div className="client-email-cell">
                              <Mail size={12} />
                              {c.email}
                            </div>
                          )}
                          {c.phone && (
                            <div className="client-phone-cell">
                              <Phone size={12} />
                              {c.phone}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="td-cpf">{cpf}</td>
                    {!isAtendente && <td className="td-mat">{matricula}</td>}
                    <td>
                      {isAsaas
                        ? <span className="type-badge-modern type-asaas"><CreditCard size={12} /> Asaas</span>
                        : isCelcoin
                        ? <span className="type-badge-modern" style={{ background: '#dcfce7', color: '#16a34a' }}><CreditCard size={12} /> Celcoin</span>
                        : <span className="type-badge-modern type-cpfl"><Zap size={12} /> CPFL</span>
                      }
                    </td>
                    <td className="td-cidade">{cidade}</td>
                    <td className="td-plano">
                      <span className="plano-badge-modern"><Star size={10} /> {plano}</span>
                    </td>
                    <td>
                      <span className={`status-badge-modern status-${status.toLowerCase()}`}>{status}</span>
                    </td>
                    <td>
                      {(() => {
                        const pag = (!isAsaas && !isCelcoin) ? situacaoPagamento(c) : null;
                        return pag ? (
                          <span className={`pag-badge pag-${pag.situacao}`} title={pag.motivo}>
                            {ROTULO_PAG[pag.situacao] || pag.situacao}
                            {pag.situacao === 'adimplente' && pag.contaAtual && pag.contaAtual.estado === 'vencida' && (
                              <span className="pag-alerta" title="A conta deste mês já venceu sem pagamento">!</span>
                            )}
                          </span>
                        ) : (
                          <span className="pag-sem-info" title={(isAsaas || isCelcoin) ? 'Situação disponível só para clientes CPFL' : 'Sem informação de pagamento da CPFL para este cliente'}>—</span>
                        );
                      })()}
                    </td>
                    <td>
                      <div className="action-btns-modern">
                        <button className="btn-action-modern view" onClick={() => setEditingClient(c)} title="Editar cliente">
                          <Eye size={14} />
                        </button>
                        {/* ✅ Botão de Gerar Cobrança só aparece se tiver permissão */}
                        {canGenerateCharge && (
                          <button className="btn-action-modern cobranca" onClick={() => handleGerarCobranca(c)} title="Gerar Cobrança">
                            <DollarSign size={14} />
                          </button>
                        )}
                        {/* Botão de Ver Cobranças — funciona pra Asaas e CPFL */}
                        <button className="btn-action-modern payments" onClick={() => handleViewPayments(c)} title="Ver Cobranças">
                          <FileText size={14} />
                        </button>
                        <button className="btn-action-modern carteirinha" onClick={() => setCarteirinhaClient(c)} title="Ver carteirinha">
                          <CreditCard size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Clientes Pix na busca da aba Todos (os do Souli e os do Pix antigo) */}
      {activeTab === 'todos' && searched && modalidadesPorUsuario(user).includes('pix') && (
        <PixClientsTab
          embedded
          getClients={getClients}
          query={searchQuery}
          isAtendente={isAtendente}
          canCharge={canGenerateCharge}
          roles={userRoles}
          onGenerateCharge={handleGerarCobranca}
        />
      )}

      {!isAtendente && pagAtivo && pagTodos && linhasPag.length > pagVisiveis && (
        <div className="pag-mais">
          <button type="button" onClick={() => setPagVisiveis(pagVisiveis + 100)}>Mostrar mais ({linhasPag.length - pagVisiveis} restantes)</button>
        </div>
      )}

      {/* Paginação */}
      {(!isAtendente || searched) && !searched && !pagAtivo && activeTab !== 'asaas' && activeTab !== 'pix' && !cpflLoading && cpflTotalPages > 1 && (
        <div className="pagination-modern">
          <button className="pag-btn-modern" onClick={() => loadCpflClients(cpflPage - 1)} disabled={cpflPage === 1}>
            <ChevronLeft size={16} />
          </button>
          <span className="pag-info-modern">Página {cpflPage} de {cpflTotalPages}</span>
          <button className="pag-btn-modern" onClick={() => loadCpflClients(cpflPage + 1)} disabled={cpflPage === cpflTotalPages}>
            <ChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );

  // ── Render Register ────────────────────────────────────────────────────────
  // modalidades que este usuário pode usar no cadastro (se só houver uma, já vem selecionada)
  const modalidadesRegistro = modalidadesPorUsuario(user);
  const metodoEfetivo = paymentMethod || (modalidadesRegistro.length === 1 ? modalidadesRegistro[0] : null);

  const renderRegister = () => (
    <div className="clients-view">
      <div className="page-topbar">
        <div>
          <h2 className="view-title" style={{ margin: 0 }}>Cadastro de Clientes — Selecione</h2>
          <p className="step-description" style={{ margin: '4px 0 0 0' }}>Selecione a modalidade de pagamento</p>
        </div>
        <button className="back-button" style={{ margin: 0 }} onClick={() => { setView('menu'); setPaymentMethod(null); }}>
          <ArrowLeft size={16} /> Voltar
        </button>
      </div>
      <div className="payment-methods-grid">
        {[
          { id: 'cpfl', Icon: Zap, cls: 'icon-cpfl', label: 'CPFL', desc: 'Débito direto em conta de luz' },
          { id: 'asaas', Icon: CreditCard, cls: 'icon-asaas', label: 'Asaas', desc: 'Boleto e cartão de crédito' },
          { id: 'pix', Icon: Smartphone, cls: 'icon-pix', label: 'Pix Santander', desc: 'Pix recorrente' },
        ].filter(m => modalidadesRegistro.includes(m.id)).map(m => (
          <div key={m.id} className={`payment-card ${metodoEfetivo === m.id ? 'selected' : ''}`} onClick={() => setPaymentMethod(m.id)}>
            <m.Icon size={36} className={m.cls} />
            <h3>{m.label}</h3>
            <p>{m.desc}</p>
          </div>
        ))}
      </div>
      <button className="btn-next" disabled={!metodoEfetivo} onClick={() => { if (metodoEfetivo) { setPaymentMethod(metodoEfetivo); setRegisterStep(2); } }}>
        Próximo <ArrowRight size={16} />
      </button>
    </div>
  );

  // ✅ RETORNO PRINCIPAL COM MODAL DE COBRANÇAS FORA DO renderSearch
  return (
    <div className="clients-container">
      {view === 'menu' && renderMenu()}
      {view === 'search' && renderSearch()}
      {view === 'register' && renderRegister()}

      {/* ✅ Modal de Cobranças - AGORA FORA DO renderSearch (funciona sempre) */}
      {paymentsModalClient && (
        <ClientPaymentsModal
          client={paymentsModalClient}
          onClose={() => setPaymentsModalClient(null)}
        />
      )}
    </div>
  );
}
